import React, { useState } from "react";
import "../../styles/CountyMap.css";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import UtahHousingChart from "./UtahHousingChart";
import UtahHousingChartYTD from "./UtahHousingChartYTD";
import { Info } from "lucide-react";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";

const housingunits = "/img/housingunit.png";
const medianhomeimg = "/img/medianhome.png";
const updateimg = "/img/update.png";

const UtahHousingMap = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const renderTooltip1 = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Beaver County
      <br />
      1,965 Housing Units
    </Tooltip>
  );

  const renderTooltip2 = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Box Elder County
      <br />
      14,449 Housing Units
    </Tooltip>
  );

  const renderTooltip3 = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Kane County
      <br />
      2,607 Housing Units
    </Tooltip>
  );

  const renderTooltip4 = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Morgan County
      <br />
      3,251 Housing Units
    </Tooltip>
  );

  const renderTooltip5 = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Salt Lake County
      <br />
      279,101 Housing Units
    </Tooltip>
  );

  const renderTooltip6 = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Summit County
      <br />
      11,635 Housing Units
    </Tooltip>
  );

  const renderTooltip7 = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Tooele County
      <br />
      19,048 Housing Units
    </Tooltip>
  );

  const renderTooltip8 = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Uintah County
      <br />
      8,602 Housing Units
    </Tooltip>
  );

  const renderTooltip9 = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Wasatch County
      <br />
      9,457 Housing Units
    </Tooltip>
  );

  const renderTooltip10 = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Carbon County
      <br />
      5,465 Housing Units
    </Tooltip>
  );

  const renderTooltip11 = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Grand County
      <br />
      3,116 Housing Units
    </Tooltip>
  );

  const renderTooltip12 = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Juab County
      <br />
      3,044 Housing Units
    </Tooltip>
  );

  const renderTooltip13 = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Rich County
      <br />
      657 Housing Units
    </Tooltip>
  );

  const renderTooltip14 = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Garfield County
      <br />
      1,490 Housing Units
    </Tooltip>
  );

  const renderTooltip15 = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Daggett County
      <br />
      1147 Housing Units
    </Tooltip>
  );

  const renderTooltip16 = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Iron County
      <br />
      13,255 Housing Units
    </Tooltip>
  );

  const renderTooltip17 = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Millard County
      <br />
      3,346 Housing Units
    </Tooltip>
  );

  const renderTooltip18 = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Sevier County
      <br />
      5,906 Housing Units
    </Tooltip>
  );

  const renderTooltip19 = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Duchesne County
      <br />
      5,324 Housing Units
    </Tooltip>
  );

  const renderTooltip20 = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      San Juan County
      <br />
      3,712 Housing Units
    </Tooltip>
  );

  const renderTooltip21 = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Piute County
      <br />
      525 Housing Units
    </Tooltip>
  );

  const renderTooltip22 = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Wayne County
      <br />
      822 Housing Units
    </Tooltip>
  );

  const renderTooltip23 = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Cache County
      <br />
      27,431 Housing Units
    </Tooltip>
  );

  const renderTooltip24 = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Washington County
      <br />
      48,574 Housing Units
    </Tooltip>
  );

  const renderTooltip25 = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Sanpete County
      <br />
      6,691 Housing Units
    </Tooltip>
  );

  const renderTooltip26 = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Emery County
      <br />
      2,727 Housing Units
    </Tooltip>
  );

  const renderTooltip27 = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Davis County
      <br />
      88,759 Housing Units
    </Tooltip>
  );

  const renderTooltip28 = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Utah County
      <br />
      133,266 Housing Units
    </Tooltip>
  );

  const renderTooltip29 = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Weber County
      <br /> 68,853 Housing Units
    </Tooltip>
  );

  const [countyname, setCountyName] = useState("Beaver County");
  const [countyhouse, setCountyHouse] = useState("1,965");
  const [medianhome, setMedianHome] = useState("$379K");
  const [color, setColor] = useState("#FF6F61");
  const [chartsData, setChartsData] = useState({
    "County Name": "Beaver County",
    "No: of Housing Units (Owner Occupied)": "1,965",
    "Median Home Value": "$379K",
    "04-2024": "$350,000",
    "04-2025": "$350,000",
    "Increase/Decrease": "0.0%",
    "2024 YTD": "$363,500",
    "2025 YTD": "$350,000",
    "Increase/DecreaseYTD": "-3.7%",
    Color: "#FF6F61",
  });

  const showData = (data) => {
    setCountyName(data["County Name"]);
    setCountyHouse(data["No: of Housing Units (Owner Occupied)"]);
    setMedianHome(data["Median Home Value"]);
    setColor(data.Color);
    setChartsData(data);
  };

  return (
    <>
      <div>
        <div className="text-center mb-12">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-blue-900 mb-2">
            Utah Housing Trends
          </h1>
        </div>

        <div className="tabtitle flex items-center gap-2 text-gray-800 mt-8">
          <Info
            className="text-blue-600 flex-shrink-0 cursor-pointer"
            size={20}
            onMouseEnter={handlePopoverOpen}
            onMouseLeave={handlePopoverClose}
          />
          <Popover
            id="mouse-over-popover"
            sx={{ pointerEvents: "none" }}
            open={open}
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            onClose={handlePopoverClose}
            disableRestoreFocus
          >
            <Typography sx={{ p: 1 }}>Click on County</Typography>
          </Popover>

          <p className="m-0">
            Select a county from the map, to display its housing trends:
          </p>
        </div>

        <div className="utah-housing-map-wrapper">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 412 411.176"
            className="svgmap"
          >
            <OverlayTrigger
              placement="right"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip1}
            >
              <path
                id="49001"
                className="county"
                d="M47.396,284.895L101.824,284.923L110.945,284.923L129.617,284.919L144.641,284.903L144.499,287.064L144.616,288.324L144.187,289.078L144.445,289.961L144.426,290.804L144.978,291.715L144.413,292.323L144.988,293.416L145.496,293.546L146.036,294.72L146.934,295.012L148.595,296.533L149.138,298.407L149.646,298.731L150.335,298.346L150.888,297.315L151.761,297.634L152.031,298.65L151.714,299.321L152.485,300.458L153.2,300.523L154.292,301.982L154.435,302.544L155.534,303.159L156.039,304.363L155.702,304.913L155.836,305.976L155.216,306.562L155.305,307.701L155.077,308.444L154.33,309.207L153.978,310.181L153.168,310.96L153.225,311.452L154.283,312.861L154.664,313.022L154.175,313.825L152.266,314.56L152.088,315.096L150.415,316.581L150.529,317.395L149.742,317.976L149.821,318.795L149.151,319.073L146.969,319.282L138.385,319.23L133.247,319.274L125.53,319.274L97.708,319.178L72.211,319.174L47.412,319.174L47.396,311.012L47.444,309.825L47.374,290.808Z"
                strokeWidth="1"
                onClick={() =>
                  showData({
                    "County Name": "Beaver County",
                    "No: of Housing Units (Owner Occupied)": "1,965",
                    "Median Home Value": "$379K",
                    "04-2024": "$350,000",
                    "04-2025": "$350,000",
                    "Increase/Decrease": "0.0%",
                    "2024 YTD": "$363,500",
                    "2025 YTD": "$350,000",
                    "Increase/DecreaseYTD": "-3.7%",
                    Color: "#FF6F61",
                  })
                }
                stroke="black"
                fill={countyname === "Beaver County" ? "#FF6F6180" : "#FF6F61"}
              />
            </OverlayTrigger>

            <OverlayTrigger
              placement="right"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip2}
            >
              <path
                id="49003"
                className="county"
                d="M166.862,0.414L167.551,1.412L167.738,2.644L168.51,3.177L169.418,5.168L169.574,6.255L170.634,7.729L171.882,8.373L173.261,10.774L173.245,11.379L173.95,11.528L174.372,13.584L175.093,15.124L175.452,15.388L175.366,16.307L176.144,16.77L176.751,17.617L176.376,18.803L175.626,19.164L175.169,20.202L175.153,21.438L174.512,22.658L174.591,24.744L174.013,25.64L174.442,26.769L175.341,27.194L176.147,28.832L176.49,30.058L176.316,30.588L176.849,31.802L177.065,33.07L176.82,34.041L177.757,37.944L178.45,39.71L179.037,38.91L179.707,38.91L180.714,38.109L181.308,38.308L181.52,39.088L182.352,39.295L182.775,39.922L183.305,42.865L184.639,42.937L185.325,43.805L185.007,44.778L183.874,45.176L182.816,45.154L182.584,45.95L183.626,46.517L184.201,47.536L184.801,47.57L184.556,48.822L184.077,49.523L183.372,49.464L182.502,50.001L181.219,49.718L179.942,48.192L179.05,49.354L179.342,50.212L179.358,51.464L178.866,52.921L179.615,53.999L177.097,55.321L176.744,55.802L176.011,55.76L175.48,56.41L168.859,56.381L162.212,56.41L146.029,78.277L126.648,84.742L110.192,84.742L47.905,84.746L48.025,43.301L47.981,42.607L48.041,32.018L48.047,21.086L47.968,12.856L48.063,9.944L47.93,0.67L50.96,0.755L57.336,1.152L72.799,0.909L82.202,0.747L82.475,0.704L98.042,0.508L98.15,0.456L121.5,0.226L132.352,0.107L136.239,0.107L165.071,0.034Z"
                strokeWidth="1"
                onClick={() =>
                  showData({
                    "County Name": "Box Elder County",
                    "No: of Housing Units (Owner Occupied)": "14,499",
                    "Median Home Value": "$474.7K",
                    "04-2024": "$417,500",
                    "04-2025": "$428,000",
                    "Increase/Decrease": "2.5%",
                    "2024 YTD": "$410,000",
                    "2025 YTD": "$434,000",
                    "Increase/DecreaseYTD": "5.9%",
                    Color: "#FFA07A",
                  })
                }
                stroke="black"
                fill={
                  countyname === "Box Elder County" ? "#FFA07A80" : "#FFA07A"
                }
              />
            </OverlayTrigger>

            <OverlayTrigger
              placement="right"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip3}
            >
              <path
                id="49025"
                className="county"
                d="M120.208,371.212L120.198,367.742L133.974,367.722L135.032,367.77L152.203,367.79L154.413,367.77L154.403,368.306L166.849,368.274L166.849,368.346L187.386,368.354L187.383,368.042L208.053,368.05L239.892,368.002L240.613,367.958L256.456,367.978L263.065,367.934L262.227,369.033L261.858,370.329L261.861,371.647L262.976,371.719L263.414,372.399L261.449,373.014L259.889,372.686L258.451,372.702L258.152,373.094L258.009,374.448L256.949,374.352L256.755,374.991L258.054,376.357L259.508,376.341L259.718,376.748L259.232,378.193L258.26,379.251L257.279,378.724L256.368,378.716L256.31,379.299L257.095,380.384L258.254,381.334L257.47,382.459L257.381,383.567L256.456,382.997L256.088,384.369L255.285,384.648L254.738,385.334L253.287,385.469L252.541,385.174L249.867,383.36L248.908,383.288L248.663,383.958L249.175,385.015L250.759,385.669L250.975,387.223L250.454,387.685L248.663,388.203L248.676,388.984L249.454,389.992L249.219,390.63L248.136,390.909L247.844,391.375L248.266,391.837L248.536,392.94L247.419,393.676L247.234,394.106L247.723,394.85L247.06,396.168L247.025,397.023L245.612,396.828L245.151,398.412L244.694,399.227L243.84,398.893L243.43,399.299L243.786,400.297L243.096,401.224L241.874,400.85L241.731,401.924L241.14,402.194L239.791,401.828L239.365,402.158L238.171,402.357L237.638,403.064L237.006,403.124L236.501,402.444L235.926,402.802L234.198,402.85L232.998,402.436L232.159,403.792L231.01,403.712L230.219,402.655L229.359,402.87L228.831,403.915L226.932,406.446L226.348,406.466L225.884,405.485L225.516,405.525L224.935,406.971L225.087,407.4L225.954,407.634L225.726,408.901L224.979,409.302L223.693,406.76L222.521,406.287L221.785,405.739L221.327,406.097L221.365,407.006L221.826,407.574L222.636,407.487L222.718,407.932L221.188,409.032L221.426,409.786L220.711,410.052L219.663,409.417L218.841,410.303L217.374,410.847L214.83,410.632L214.506,410.898L200.419,410.906L185.823,410.914L154.635,410.934L141.879,410.962L120.322,410.989L120.325,388.646L120.192,388.646Z"
                data-item='{"area":10333973705,"county":{"year":2024,"fips":49025,"pop2020":7693,"pop2024":8647,"state":"Utah","stateCode":"UT","growthSince2020":0.12400883920447159,"name":"Kane County","county":"Kane County","slug":"utah/kane-county","landArea":3994,"density":2.1649974962443665,"rank":23,"densityMi":2.1649974962443665,"areaMi":3994}}'
                strokeWidth="1"
                onClick={() =>
                  showData({
                    "County Name": "Kane County",
                    "No: of Housing Units (Owner Occupied)": "2,607",
                    "Median Home Value": "$599.9K",
                    "04-2024": "$610,000",
                    "04-2025": "$255,000",
                    "Increase/Decrease": "-58.2%",
                    "2024 YTD": "$508,700",
                    "2025 YTD": "$449,250",
                    "Increase/DecreaseYTD": "-11.7%",
                    Color: "#D1F26D",
                  })
                }
                stroke="black"
                fill={countyname === "Kane County" ? "#D1F26D80" : "#D1F26D"}
              ></path>
            </OverlayTrigger>
            <OverlayTrigger
              placement="right"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip4}
            >
              <path
                id="49029"
                className="county"
                d="M214.001,54.32L215.024,54.244L215.09,53.644L216.31,53.247L217.405,54.29L218.704,54.303L219.101,54.814L219.628,54.645L219.927,55.642L220.46,55.794L221.975,56.963L221.861,57.901L222.134,58.698L223.255,59.521L224.071,59.77L224.093,60.593L223.09,61.399L223.284,62.496L223.096,64.136L223.573,64.823L222.836,65.818L224.576,65.481L224.69,66.695L225.856,66.379L226.608,66.644L225.964,68.077L226.361,68.654L225.729,69.274L225.888,69.855L225.287,70.904L223.871,72.63L222.239,72.706L221.232,73.72L219.628,73.14L218.749,73.918L217.393,73.855L217.37,74.684L216.729,75.677L216.542,77.428L214.239,78.521L213.83,78.042L212.397,77.836L210.746,79.274L209.577,79.606L208.466,79.434L206.376,80.935L205.49,82.032L205.595,82.998L205.255,83.813L203.918,85.078L203.426,85.048L203.042,85.884L203.426,86.523L203.41,87.619L204.074,88.227L205.255,88.152L205.7,88.593L206.808,88.248L207.405,88.647L207.154,91.522L208.034,91.711L208.444,92.336L208.361,93.313L209.857,95.376L210.266,96.601L209.749,96.953L208.615,99.379L207.907,99.878L208.291,100.632L207.748,102.198L207.002,102.814L205.503,103.174L203.41,102.031L203.01,101.084L201.943,100.577L200.041,101.591L200.168,100.724L199.749,99.488L198.453,98.813L198.809,97.686L197.945,96.873L196.224,96.374L195.881,97.083L194.747,96.923L193.852,96.395L193.328,95.54L191.978,95.427L192.391,94.378L191.857,94.097L191.073,92.055L190.384,91.795L190.552,90.796L189.717,89.713L188.993,88.311L190.555,88.022L191.552,88.152L190.412,85.935L189.307,84.309L188.704,84.196L188.145,82.99L187.538,82.763L187.837,81.628L187.472,81.321L187.186,80.014L186.687,79.139L186.906,78.374L186.414,75.332L187.148,74.503L186.865,73.497L186.408,73.047L186.513,71.75L185.5,71.194L185.118,70.466L185.608,69.514L185.347,68.949L186.281,68.124L188.856,67.525L189.215,66.889L189.984,66.472L191.587,66.392L192.273,67.041L193.394,66.872L193.423,67.601L194.525,68.149L195.258,69.076L195.935,69.337L197.7,69.501L198.421,68.966L198.926,69.122L200.085,68.01L201.105,67.888L201.883,67.116L202.057,65.46L202.851,64.672L205.195,64.528L206.745,64.874L207.323,65.498L208.596,65.317L209.158,65.654L209.32,64.474L210.416,64.107L210.362,63.668L211.232,63.023L211.635,61.745L212.455,61.344L212.839,59.935L212.185,58.167L212.937,57.521L212.909,56.292L213.652,55.849Z"
                data-item='{"area":1577750990,"county":{"year":2024,"fips":49029,"pop2020":12382,"pop2024":13163,"state":"Utah","stateCode":"UT","growthSince2020":0.06307543207882405,"name":"Morgan County","county":"Morgan County","slug":"utah/morgan-county","landArea":609,"density":21.614121510673236,"rank":20,"densityMi":21.614121510673236,"areaMi":609}}'
                strokeWidth="1"
                onClick={() =>
                  showData({
                    "County Name": "Morgan County",
                    "No: of Housing Units (Owner Occupied)": "3,251",
                    "Median Home Value": "$949K",
                    "04-2024": "$650,000",
                    "04-2025": "$812,500",
                    "Increase/Decrease": "25.0%",
                    "2024 YTD": "$669,000",
                    "2025 YTD": "$655,000",
                    "Increase/DecreaseYTD": "-2.1%",
                    Color: "#AFEEEE",
                  })
                }
                stroke="black"
                fill={countyname === "Morgan County" ? "#AFEEEE80" : "#AFEEEE"}
              ></path>
            </OverlayTrigger>

            <OverlayTrigger
              placement="right"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip5}
            >
              <path
                id="49035"
                className="county"
                d="M160.809,104.091L167.903,97.64L176.881,91.295L179.917,91.295L179.92,93.112L179.278,94.223L179.132,95.083L179.669,95.745L179.424,96.655L180.095,97.389L180.908,98.876L180.727,99.677L185.477,99.685L186.57,99.052L188.567,98.637L189.171,98.147L189.691,98.29L190.654,97.686L191.127,97.824L193.852,96.395L194.747,96.923L195.881,97.083L196.224,96.374L197.945,96.873L198.809,97.686L198.453,98.813L199.749,99.488L200.168,100.724L200.041,101.591L199.555,102.152L199.914,102.68L199.53,103.726L200.273,104.522L201.292,104.999L201.454,105.748L201.111,106.388L201.21,107.351L203.026,109.634L202.527,111.144L202.362,112.661L203.029,113.907L203.941,114.437L204.118,115.403L204.706,116.276L205.335,116.606L205.605,117.441L205.224,118.092L204.922,119.474L203.248,119.863L203.026,120.13L202.477,120.343L202.273,121.186L200.228,120.906L199.46,122.296L198.723,122.417L198.58,123.122L197.281,123.948L196.427,123.577L195.474,123.831L194.985,124.457L194.017,123.885L193.534,124.678L192.483,124.119L190.739,125.408L190.628,126.742L189.504,127.451L188.939,127.459L185.985,129.118L185.334,128.468L184.118,129.547L183.578,129.601L183.169,130.414L181.66,132.084L179.831,133.35L178.431,133.7L177.767,132.884L176.881,132.659L176.624,131.789L176.271,131.972L175.302,130.672L174.893,129.51L174.315,130.168L173.067,131.022L171.371,130.901L170.209,131.643L170.025,130.664L168.945,129.518L168.195,129.026L167.151,129.801L166.344,129.301L166.427,128.955L165.829,127.238L165.909,126.371L165.413,125.383L165.972,124.719L165.718,123.343L166.001,121.853L165.709,121.374L165.801,119.854L166.214,119.437L166.188,117.884L164.772,116.092L164.997,115.244L164.493,113.865L164.359,111.253L164.712,110.433L164.14,108.551L162.863,107.727Z"
                data-item='{"area":1921958791,"county":{"year":2024,"fips":49035,"pop2020":1186983,"pop2024":1185057,"state":"Utah","stateCode":"UT","growthSince2020":-0.001622601166149762,"name":"Salt Lake County","county":"Salt Lake County","slug":"utah/salt-lake-county","landArea":753,"density":1573.780876494024,"rank":1,"densityMi":1573.780876494024,"areaMi":753}}'
                strokeWidth="1"
                onClick={() =>
                  showData({
                    "County Name": "Salt Lake County",
                    "No: of Housing Units (Owner Occupied)": "279,101",
                    "Median Home Value": "$589.9K",
                    "04-2024": "$540,000",
                    "04-2025": "$536,000",
                    "Increase/Decrease": "-0.7%",
                    "2024 YTD": "$525,000",
                    "2025 YTD": "$527,250",
                    "Increase/DecreaseYTD": "0.4%",
                    Color: "#D8BFD8",
                  })
                }
                stroke="black"
                fill={
                  countyname === "Salt Lake County" ? "#D8BFD880" : "#D8BFD8"
                }
              ></path>
            </OverlayTrigger>

            <OverlayTrigger
              placement="right"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip6}
            >
              <path
                id="49043"
                className="county"
                d="M200.041,101.591L201.943,100.577L203.01,101.084L203.41,102.031L205.503,103.174L207.002,102.814L207.748,102.198L208.291,100.632L207.907,99.878L208.615,99.379L209.749,96.953L210.266,96.601L209.857,95.376L208.361,93.313L208.444,92.336L208.034,91.711L207.154,91.522L207.405,88.647L206.808,88.248L205.7,88.593L205.255,88.152L204.074,88.227L203.41,87.619L203.426,86.523L203.042,85.884L203.426,85.048L203.918,85.078L205.255,83.813L205.595,82.998L205.49,82.032L206.376,80.935L208.466,79.434L209.577,79.606L210.746,79.274L212.397,77.836L213.83,78.042L214.239,78.521L216.542,77.428L216.729,75.677L217.37,74.684L217.393,73.855L218.749,73.918L219.628,73.14L221.232,73.72L222.239,72.706L223.871,72.63L224.017,72.879L225.164,72.542L225.907,72.727L227.799,70.967L228.752,70.474L229.53,70.424L231.728,69.004L232.458,68.119L232.217,67.344L233.674,66.687L234.24,67.272L234.925,65.759L235.869,64.271L236.532,63.71L237.711,63.571L237.698,84.91L256.453,85.002L258.714,85.044L269.816,85.044L272.293,85.179L280.217,85.162L288.137,85.065L288.95,85.12L296.314,84.981L303.609,84.918L303.977,84.96L303.977,100.355L303.005,100.288L302.427,99.785L301.316,99.773L300.725,100.472L299.941,100.313L299.233,100.661L297.518,100.841L296.006,100.25L295.288,100.59L293.961,99.744L293.177,100.1L292.122,99.312L290.979,99.618L289.487,98.922L288.928,99.14L287.486,98.587L286.12,99.149L285.476,98.709L284.923,99.291L283.275,99.869L282.322,99.538L281.773,100.183L281.919,100.745L281.516,101.494L280.01,102.575L278.931,102.449L277.978,102.818L277.165,102.181L276.628,103.299L275.053,102.906L274.075,103.86L273.157,103.153L272.478,104.124L270.852,104.723L270.217,103.923L269.258,103.73L268.451,104.986L267.486,105.074L267.07,104.622L266.345,105.028L265.536,104.97L264.389,104.053L263.865,104.396L262.427,106.497L261.204,106.606L260.267,106.397L258.927,105.459L258.295,106.066L256.942,106.129L256.466,105.89L255.462,106.405L255.536,106.769L254.395,107.279L253.729,108.275L252.906,108.898L251.849,108.99L250.324,107.752L249.368,108.058L248.562,107.497L247.504,107.597L247.936,108.488L247.136,108.748L246.729,109.329L246.777,110.069L247.39,111.558L246.869,111.692L246.872,111.353L244.872,111.508L244.179,112.156L243.903,113.096L244.144,114.337L243.36,115.841L243.008,116.944L243.128,117.579L242.195,118.79L240.207,118.819L238.685,120.222L237.152,119.746L235.646,118.673L235.014,118.873L233.9,118.715L233.001,119.015L232.344,120.021L231.95,121.699L231.331,122.421L230.375,122.3L230.168,121.858L229.124,121.649L228.666,121.123L225.557,120.088L223.849,119.282L222.566,118.464L221.854,117.491L221.445,117.725L219.959,116.288L218.482,116.129L216.869,115.453L216.812,114.659L215.935,113.155L215.97,111.717L215.719,110.671L214.541,111.441L212.95,111.177L213.391,112.778L211.486,113.848L211.273,114.463L210.644,114.621L210.346,116.004L209.809,116.476L210.079,117.462L209.66,118.264L207.208,117.22L206.427,117.119L205.605,117.441L205.335,116.606L204.706,116.276L204.118,115.403L203.941,114.437L203.029,113.907L202.362,112.661L202.527,111.144L203.026,109.634L201.21,107.351L201.111,106.388L201.454,105.748L201.292,104.999L200.273,104.522L199.53,103.726L199.914,102.68L199.555,102.152Z"
                data-item='{"area":4844755736,"county":{"year":2024,"fips":49043,"pop2020":42489,"pop2024":42473,"state":"Utah","stateCode":"UT","growthSince2020":-0.0003765680529078663,"name":"Summit County","county":"Summit County","slug":"utah/summit-county","landArea":1871,"density":22.700694815606628,"rank":10,"densityMi":22.700694815606628,"areaMi":1871}}'
                strokeWidth="1"
                onClick={() =>
                  showData({
                    "County Name": "Summit County",
                    "No: of Housing Units (Owner Occupied)": "11,635",
                    "Median Home Value": "$1.7M",
                    "04-2024": "$1,425,000",
                    "04-2025": "$1,695,000",
                    "Increase/Decrease": "18.9%",
                    "2024 YTD": "$1,360,516",
                    "2025 YTD": "$1,740,000",
                    "Increase/DecreaseYTD": "27.9%",
                    Color: "#FDD5B1",
                  })
                }
                stroke="black"
                fill={countyname === "Summit County" ? "#FDD5B180" : "#FDD5B1"}
              ></path>
            </OverlayTrigger>
            <OverlayTrigger
              placement="right"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip7}
            >
              <path
                id="49045"
                className="county"
                d="M47.905,84.746L110.192,84.742L126.648,84.742L146.029,78.277L160.809,104.091L162.863,107.727L164.14,108.551L164.712,110.433L164.359,111.253L164.493,113.865L164.997,115.244L164.772,116.092L166.188,117.884L166.214,119.437L165.801,119.854L165.709,121.374L166.001,121.853L165.718,123.343L165.972,124.719L165.413,125.383L165.909,126.371L165.829,127.238L166.427,128.955L166.344,129.301L165.242,129.18L164.912,129.697L163.851,129.947L163.791,131.155L164.086,132.243L164.966,133.125L164.635,134.591L164.677,136.335L165.34,137.172L165.007,138.22L166.176,140.217L164.861,141.049L165.09,141.294L164.715,142.621L165.128,142.858L165.426,143.859L165.121,146.145L165.925,147.396L165.912,148.824L166.608,149.896L167.341,149.9L167.827,150.489L167.249,150.95L167.135,151.594L167.884,151.884L167.579,152.98L168.065,153.905L167.42,153.971L167.211,154.569L166.274,155.291L166.668,155.921L166.141,157.236L167.738,159.184L167.287,160.701L166.436,160.983L166.147,161.634L166.322,162.586L165.664,163.129L166.401,164.798L166.014,165.871L165.906,167.1L163.003,169.107L162.4,170.498L162.324,171.325L160.199,173.111L159.475,172.905L157.948,173.07L157.713,172.334L156.788,172.665L156.242,171.97L155.775,172.88L156.048,174.41L155.553,175.484L155.629,175.964L148.306,176.009L126.731,176.026L126.731,175.985L112.351,175.927L98.191,175.939L98.191,175.89L69.502,175.873L47.587,175.828L47.625,168.321L47.612,159.437L47.65,148.845L47.647,135.024L47.711,132.363L47.704,126.008L47.838,103.873Z"
                data-item='{"area":17979656909,"county":{"year":2024,"fips":49045,"pop2020":73355,"pop2024":84147,"state":"Utah","stateCode":"UT","growthSince2020":0.14712016904096514,"name":"Tooele County","county":"Tooele County","slug":"utah/tooele-county","landArea":7040,"density":11.952698863636364,"rank":7,"densityMi":11.952698863636364,"areaMi":7040}}'
                strokeWidth="1"
                onClick={() =>
                  showData({
                    "County Name": "Tooele County",
                    "No: of Housing Units (Owner Occupied)": "19,048",
                    "Median Home Value": "$514.9K",
                    "04-2024": "$444,990",
                    "04-2025": "$457,500",
                    "Increase/Decrease": "2.%",
                    "2024 YTD": "$449,990",
                    "2025 YTD": "$460,000",
                    "Increase/DecreaseYTD": "2.2%",
                    Color: "#B19CD9",
                  })
                }
                stroke="black"
                fill={countyname === "Tooele County" ? "#B19CD980" : "#B19CD9"}
              ></path>
            </OverlayTrigger>
            <OverlayTrigger
              placement="left"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip8}
            >
              <path
                id="49047"
                className="county"
                d="M305.492,184.071L305.517,100.69L307.734,101.917L308.318,101.788L309.176,102.265L309.687,103.061L310.56,103.01L310.776,103.768L311.43,103.605L312.246,104.53L314.53,104.162L314.673,103.534L317.343,102.985L318.931,102.964L319.817,101.281L321.246,101.917L321.764,101.348L322.993,101.214L324.501,101.93L325.365,101.444L326.019,101.524L326.188,101.046L327.331,100.192L328.128,100.422L328.515,99.991L329.217,100.242L330.595,99.379L331.148,100.38L333.847,99.191L334.816,100.833L334.975,101.959L334.498,102.985L334.705,103.404L334.66,105.292L336.702,106.484L337.334,106.196L337.617,105.254L338.468,105.363L339.722,105.041L339.43,104.404L339.862,103.421L341.091,102.604L342.39,102.252L342.387,96.63L354.505,96.613L354.622,102.684L357.026,102.68L357.131,103.881L357.179,111.219L359.561,111.194L359.561,113.008L364.318,112.992L364.34,116.614L364.21,123.193L364.156,131.189L364.153,153.088L364.175,178.398L364.127,209.461L362.759,209.284L362.52,210.159L361.834,209.901L361.304,210.993L361.31,211.605L360.605,212.394L328.874,212.369L306.978,212.406L306.978,211.794L302.504,211.794L302.532,210.973L303.097,209.962L302.608,209.276L302.307,207.308L301.757,207.357L300.967,206.547L301.941,206.231L302.221,204.886L301.618,203.792L302.062,202.879L302.834,202.254L302.186,200.999L303.155,199.814L303.304,198.999L304.177,198.913L303.329,198.044L303.431,197.167L304.276,197.217L305.015,195.779L304.692,194.103L303.771,194.251L304.384,193.374L304.418,192.595L305.771,192.323L305.025,190.662L304.441,189.879L304.857,189.446L306.127,189.306L306.521,189.916L306.419,190.691L307.016,191.21L307.302,190.926L306.927,190.035L307.651,188.65L308.502,188.708L309.007,186.844L308.445,184.909L308.972,184.62L309.141,185.721L309.747,185.849L310.535,185.499L311.776,185.973L311.967,185.429L310.938,184.768L311.43,184.071Z"
                data-item='{"area":11609285613,"county":{"year":2024,"fips":49047,"pop2020":35672,"pop2024":38390,"state":"Utah","stateCode":"UT","growthSince2020":0.07619421394931591,"name":"Uintah County","county":"Uintah County","slug":"utah/uintah-county","landArea":4483,"density":8.563461967432524,"rank":11,"densityMi":8.563461967432524,"areaMi":4483}}'
                strokeWidth="1"
                onClick={() =>
                  showData({
                    "County Name": "Uintah County",
                    "No: of Housing Units (Owner Occupied)": "8,602",
                    "Median Home Value": "$419.9K",
                    "04-2024": "$322,750",
                    "04-2025": "$318,250",
                    "Increase/Decrease": "-1.4%",
                    "2024 YTD": "$319,000",
                    "2025 YTD": "$330,000",
                    "Increase/DecreaseYTD": "3.4%",
                    Color: "#E8EBCF",
                  })
                }
                stroke="black"
                fill={countyname === "Uintah County" ? "#E8EBCF80" : "#E8EBCF"}
              ></path>
            </OverlayTrigger>
            <OverlayTrigger
              placement="right"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip9}
            >
              <path
                id="49051"
                className="county"
                d="M203.026,120.13L203.248,119.863L204.922,119.474L205.224,118.092L205.605,117.441L206.427,117.119L207.208,117.22L209.66,118.264L210.079,117.462L209.809,116.476L210.346,116.004L210.644,114.621L211.273,114.463L211.486,113.848L213.391,112.778L212.95,111.177L214.541,111.441L215.719,110.671L215.97,111.717L215.935,113.155L216.812,114.659L216.869,115.453L218.482,116.129L219.959,116.288L221.445,117.725L221.854,117.491L222.566,118.464L223.849,119.282L225.557,120.088L228.666,121.123L229.124,121.649L230.168,121.858L230.375,122.3L231.331,122.421L231.95,121.699L232.344,120.021L233.001,119.015L233.9,118.715L235.014,118.873L235.646,118.673L237.152,119.746L238.685,120.222L240.207,118.819L242.195,118.79L243.128,117.579L243.008,116.944L243.36,115.841L244.144,114.337L243.903,113.096L244.179,112.156L244.872,111.508L246.872,111.353L246.869,111.692L246.809,132.284L247.212,132.288L247.209,151.614L247.231,161.248L247.517,161.244L247.523,176.361L247.523,176.402L235.434,176.319L235.395,172.76L233.157,172.739L232.318,172.284L233.046,171.61L233.103,170.7L232.439,170.498L231.585,169.136L231.016,169.302L230.511,168.731L230.035,168.843L230.013,167.779L229.451,166.74L228.87,166.438L228.133,165.486L227.621,164.144L226.294,165.113L225.564,164.86L224.868,163.465L225.703,162.346L225.303,160.958L225.789,159.441L226.094,159.222L226.631,157.713L226.351,156.091L225.996,155.813L226.37,154.208L224.951,152.017L224.303,151.677L223.334,149.676L223.328,148.488L223.881,147.981L222.998,146.619L222.02,145.626L221.08,145.177L221.149,144.533L220.273,144.25L219.803,144.645L219.39,144.209L217.802,144.134L216.761,143.406L215.529,143.835L214.658,143.602L214.376,144.117L213.636,144.283L213.182,143.868L212.563,144.038L211.692,143.136L212.912,141.386L211.356,139.843L211.368,139.252L210.781,139.244L210.225,138.029L207.266,138.071L205.478,137.987L205.163,137.392L205.17,135.898L204.277,135.599L204.274,133.808L203.677,133.813L203.07,132.293L202.67,131.988L201.981,132.309L201.314,130.751L202.242,129.276L202.969,129.247L203.995,128.055L204.261,127.138L204.198,125.191L204.557,124.319L204.379,123.41L204.687,122.621L203.874,121.165Z"
                data-item='{"area":3048429878,"county":{"year":2024,"fips":49051,"pop2020":35055,"pop2024":37691,"state":"Utah","stateCode":"UT","growthSince2020":0.07519612038225643,"name":"Wasatch County","county":"Wasatch County","slug":"utah/wasatch-county","landArea":1177,"density":32.02293967714528,"rank":12,"densityMi":32.02293967714528,"areaMi":1177}}'
                strokeWidth="1"
                onClick={() =>
                  showData({
                    "County Name": "Wasatch County",
                    "No: of Housing Units (Owner Occupied)": "9,457",
                    "Median Home Value": "$1.3M",
                    "04-2024": "$975,000",
                    "04-2025": "$923,650",
                    "Increase/Decrease": "-5.3%",
                    "2024 YTD": "$910,000",
                    "2025 YTD": "$1,076,619",
                    "Increase/DecreaseYTD": "18.3%",
                    Color: "#FFD700",
                  })
                }
                stroke="black"
                fill={countyname === "Wasatch County" ? "#FFD70080" : "#FFD700"}
              ></path>
            </OverlayTrigger>

            <OverlayTrigger
              placement="right"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip10}
            >
              <path
                id="49007"
                className="county"
                d="M224.976,183.51L235.65,183.576L235.65,183.419L249.67,183.489L254.596,183.53L271.188,183.625L271.188,184.03L300.011,184.063L305.492,184.071L311.43,184.071L310.938,184.768L311.967,185.429L311.776,185.973L310.535,185.499L309.747,185.849L309.141,185.721L308.972,184.62L308.445,184.909L309.007,186.844L308.502,188.708L307.651,188.65L306.927,190.035L307.302,190.926L307.016,191.21L306.419,190.691L306.521,189.916L306.127,189.306L304.857,189.446L304.441,189.879L305.025,190.662L305.771,192.323L304.418,192.595L304.384,193.374L303.771,194.251L304.692,194.103L305.015,195.779L304.276,197.217L303.431,197.167L303.329,198.044L304.177,198.913L303.304,198.999L303.155,199.814L302.186,200.999L302.834,202.254L302.062,202.879L301.618,203.792L302.221,204.886L301.941,206.231L300.967,206.547L301.757,207.357L302.307,207.308L302.608,209.276L303.097,209.962L302.532,210.973L302.504,211.794L302.494,211.794L272.506,211.766L255.99,211.79L235.745,211.757L235.926,209.999L235.58,209.654L235.24,207.476L234.379,206.268L233.852,206.144L233.912,205.45L233.287,205.01L233.106,203.398L232.337,200.477L231.931,199.802L231.267,201.028L230.578,201.386L229.857,200.777L229.501,199.876L228.86,199.452L228.45,197.653L227.863,197.307L227.904,196.356L226.615,194.857L226.643,193.584L226.081,192.863L224.986,192.467Z"
                data-item='{"area":3830974536,"county":{"year":2024,"fips":49007,"pop2020":20487,"pop2024":20678,"state":"Utah","stateCode":"UT","growthSince2020":0.009322985307756104,"name":"Carbon County","county":"Carbon County","slug":"utah/carbon-county","landArea":1479,"density":13.98106828938472,"rank":16,"densityMi":13.98106828938472,"areaMi":1479}}'
                strokeWidth="1"
                onClick={() =>
                  showData({
                    "County Name": "Carbon County",
                    "No: of Housing Units (Owner Occupied)": "5,465",
                    "Median Home Value": "$330K",
                    "04-2024": "$225,000",
                    "04-2025": "$256,300",
                    "Increase/Decrease": "13.9%",
                    "2024 YTD": "$222,500",
                    "2025 YTD": "$258,000",
                    "Increase/DecreaseYTD": "16%",
                    Color: "#77DD77",
                  })
                }
                stroke="black"
                fill={countyname === "Carbon County" ? "#77DD7780" : "#77DD77"}
              ></path>
            </OverlayTrigger>

            <OverlayTrigger
              placement="left"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip11}
            >
              <path
                id="49019"
                className="county"
                d="M302.494,211.794L302.504,211.794L306.978,211.794L306.978,212.406L328.874,212.369L360.605,212.394L361.31,211.605L361.304,210.993L361.834,209.901L362.52,210.159L362.759,209.284L364.127,209.461L364.165,220.207L364.118,239.89L364.061,250.184L363.949,260.366L363.746,266.833L363.61,272.976L363.565,282.757L363.584,290.804L343.625,290.808L326.07,290.812L302.411,290.808L301.433,290.383L301.132,289.621L301.662,289.297L303.024,289.674L303.186,288.823L303.977,289.042L304.384,288.608L303.679,287.258L304.774,285.86L303.977,285.357L303.253,285.856L302.862,285.645L302.418,284.55L301.849,285.028L301.214,284.538L300.509,284.493L300.354,284.023L301.856,282.372L302.402,282.704L303.199,283.751L304.256,283.134L304.215,281.986L303.834,281.057L302.98,280.822L302.713,281.775L300.477,282.303L299.661,281.645L299.874,281.159L301.195,281.43L301.379,281.118L300.887,279.994L301.719,278.46L301.163,277.879L300.741,278.971L300.35,278.894L300.214,277.688L299.553,278.139L299.668,277.026L299.283,276.762L298.401,277.428L297.994,277.172L298.509,276.49L297.823,275.564L297.804,274.841L298.575,273.915L298.267,273.411L297.543,273.501L296.829,274.061L296.444,273.578L297.292,273.155L296.864,272.021L297.632,270.676L298.709,270.371L298.829,269.989L298.283,268.855L297.216,268.31L296.314,267.081L297.273,266.512L297.295,265.601L296.819,264.937L296.181,264.799L296.457,264.229L296.057,263.729L295.355,263.643L294.771,262.967L295.409,261.526L294.977,260.822L294.428,261.311L293.723,261.266L293.894,259.05L293.561,258.411L292.662,257.739L292.824,256.353L293.256,256.125L295.123,256.349L295.485,255.591L295.05,254.654L294.348,254.283L295.288,253.426L294.561,252.472L294.495,251.828L299.642,251.897L299.642,253.08L300.82,253.08L300.82,253.671L301.411,253.671L301.411,254.262L303.767,254.266L303.771,253.08L302.589,253.08L302.592,251.897L301.411,251.897L301.411,250.71L300.233,250.71L300.233,251.302L297.918,251.302L297.918,250.045L295.536,250.041L295.533,250.641L294.507,250.408L294.501,250.009L295.279,249.846L294.282,248.989L295.133,248.111L294.123,247.52L295.158,245.478L295.142,244.392L294.812,243.87L295.222,242.93L296.571,242.35L297.092,240.965L296.746,240.32L297.038,239.453L297.721,239.061L296.66,237.732L296.908,237.082L297.781,236.403L297.349,235.63L297.762,234.71L299.026,234.383L299.369,233.769L299.09,231.711L299.906,231.948L300.563,231.539L299.992,229.767L300.049,228.395L299.125,227.645L299.757,226.175L300.874,225.626L300.249,225.061L300.719,223.569L301.802,222.335L301.862,221.659L302.618,221.409L302.764,220.543L302.43,219.321L302.812,219.207L302.681,218.288L303.348,216.138L302.535,215.584L302.707,215.14L302.564,213.679L302.97,212.804Z"
                data-item='{"area":9512638635,"county":{"year":2024,"fips":49019,"pop2020":9674,"pop2024":9641,"state":"Utah","stateCode":"UT","growthSince2020":-0.00341120529253669,"name":"Grand County","county":"Grand County","slug":"utah/grand-county","landArea":3673,"density":2.624829839368364,"rank":22,"densityMi":2.624829839368364,"areaMi":3673}}'
                strokeWidth="1"
                onClick={() =>
                  showData({
                    "County Name": "Grand County",
                    "No: of Housing Units (Owner Occupied)": "3,116",
                    "Median Home Value": "$659K",
                    "04-2024": "$499,500",
                    "04-2025": "$665,000",
                    "Increase/Decrease": "33.1%",
                    "2024 YTD": "$515,000",
                    "2025 YTD": "$565,000",
                    "Increase/DecreaseYTD": "9.7%",
                    Color: "#F0E9DF",
                  })
                }
                stroke="black"
                fill={countyname === "Grand County" ? "#F0E9DF80" : "#F0E9DF"}
              ></path>
            </OverlayTrigger>
            <OverlayTrigger
              placement="right"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip12}
            >
              <path
                id="49023"
                className="county"
                d="M47.587,175.828L69.502,175.873L98.191,175.89L98.191,175.939L112.351,175.927L126.731,175.985L126.731,176.026L148.306,176.009L155.629,175.964L155.553,175.484L156.048,174.41L155.775,172.88L156.242,171.97L156.788,172.665L157.713,172.334L157.948,173.07L159.475,172.905L160.199,173.111L162.324,171.325L162.4,170.498L163.003,169.107L165.906,167.1L167.157,167.506L167.738,168.607L168.894,169.931L170.336,170.233L170.809,171.466L171.333,171.83L170.803,172.342L170.733,173.955L171.895,174.224L172.149,175.245L173.334,175.943L173.908,176.877L173.55,177.951L172.152,179.216L172.603,180.665L172.533,181.309L173.153,182.106L172.435,184.574L171.768,185.358L171.606,186.072L172.968,186.452L173.267,186.076L174.309,186.493L174.664,185.948L175.639,186.01L176.281,185.259L177.621,184.463L177.938,183.65L179.237,183.984L179.663,183.258L179.523,182.498L180.012,181.545L180.441,181.747L180.574,180.541L181.282,180.017L182.26,178.439L183.035,176.778L184.194,176.468L184.804,175.72L185.776,175.856L186.233,175.112L187.881,174.306L187.897,173.298L188.253,172.446L190.298,173.757L190.841,174.567L190.793,175.567L191.378,176.394L191.956,176.468L192.638,177.121L192.721,178.369L193.902,179.311L194.14,180.149L193.35,180.463L193.242,181.768L192.594,182.573L192.111,183.708L192.842,183.572L199.984,183.522L199.977,184.723L201.241,184.711L201.216,185.92L203.601,185.882L203.607,189.52L199.949,189.553L199.942,190.753L198.755,190.761L198.755,191.371L197.551,191.387L197.558,191.985L196.967,191.973L196.973,193.217L195.198,193.271L195.214,198.011L195.344,198.011L195.309,205.314L195.465,205.318L195.468,212.529L193.283,212.55L193.324,218.891L182.216,218.985L182.26,220.195L179.91,220.252L179.952,222.655L176.296,222.651L176.284,224.479L172.721,224.45L172.73,223.237L165.328,223.266L165.328,219.682L165.032,219.682L165.051,210.106L164.458,210.106L164.458,208.915L163.867,208.319L163.867,207.131L165.055,207.135L165.051,205.947L164.458,205.951L163.864,204.837L162.346,204.866L147.998,204.862L147.998,204.964L137.411,204.969L118.788,204.956L62.249,204.948L62.249,205.651L47.549,205.762Z"
                data-item='{"area":8784471158,"county":{"year":2024,"fips":49023,"pop2020":11819,"pop2024":13460,"state":"Utah","stateCode":"UT","growthSince2020":0.13884423386073275,"name":"Juab County","county":"Juab County","slug":"utah/juab-county","landArea":3392,"density":3.9681603773584904,"rank":19,"densityMi":3.9681603773584904,"areaMi":3392}}'
                strokeWidth="1"
                onClick={() =>
                  showData({
                    "County Name": "Juab County",
                    "No: of Housing Units (Owner Occupied)": "3,044",
                    "Median Home Value": "$499.9K",
                    "04-2024": "$426,500",
                    "04-2025": "$500,000",
                    "Increase/Decrease": "17.2%",
                    "2024 YTD": "$475,000",
                    "2025 YTD": "$482,500",
                    "Increase/DecreaseYTD": "1.6%",
                    Color: "#A2D5C6",
                  })
                }
                stroke="black"
                fill={countyname === "Juab County" ? "#A2D5C680" : "#A2D5C6"}
              ></path>
            </OverlayTrigger>
            <OverlayTrigger
              placement="right"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip13}
            >
              <path
                id="49033"
                className="county"
                d="M208.485,0.175L213.696,0.064L221.654,0.047L237.701,0L237.758,37.05L237.711,63.571L236.532,63.71L235.869,64.271L234.925,65.759L234.24,67.272L233.674,66.687L232.217,67.344L232.458,68.119L231.728,69.004L229.53,70.424L228.752,70.474L227.799,70.967L225.907,72.727L225.164,72.542L224.017,72.879L223.871,72.63L225.287,70.904L225.888,69.855L225.729,69.274L226.361,68.654L225.964,68.077L226.608,66.644L225.856,66.379L224.69,66.695L224.576,65.481L222.836,65.818L223.573,64.823L223.096,64.136L223.284,62.496L223.09,61.399L224.093,60.593L224.071,59.77L223.255,59.521L222.134,58.698L221.861,57.901L221.975,56.963L220.46,55.794L219.927,55.642L219.628,54.645L219.101,54.814L218.704,54.303L217.405,54.29L216.31,53.247L215.09,53.644L215.024,54.244L214.001,54.32L212.404,53.868L212.264,53.344L211.464,53.23L211.184,52.676L210.397,52.372L210.53,51.062L208.987,50.301L208.291,49.101L208.93,47.874L208.625,47.426L208.93,45.607L209.622,45.442L210.565,43.03L210.368,42.264L211.06,41.815L211.743,40.829L211.705,39.871L212.594,39.943L212.451,38.846L213.217,38.058L213.601,35.355L213.423,32.591L214.639,31.806L214.261,30.805L215.214,29.549L214.868,28.475L214.436,28.501L214.335,27.677L213.614,27.529L214.23,24.582L214.03,23.563L212.648,22.59L212.715,20.916L212.559,19.564L211.851,18.897L212.089,17.77L211.467,15.716L211.06,15.15L208.482,12.686L208.857,11.975L208.39,11.311L209.349,10.898L209.38,9.748L208.803,9.701L208.955,8.803L208.259,8.215L208.815,7.491L209.917,7.746L210.797,6.255L210.47,5.671L210.673,4.61L210.508,3.745L209.974,3.032L209.971,2.235L209.136,1.403L208.472,1.182Z"
                data-item='{"area":2664700973,"county":{"year":2024,"fips":49033,"pop2020":2505,"pop2024":2691,"state":"Utah","stateCode":"UT","growthSince2020":0.07425149700598799,"name":"Rich County","county":"Rich County","slug":"utah/rich-county","landArea":1029,"density":2.6151603498542273,"rank":26,"densityMi":2.6151603498542273,"areaMi":1029}}'
                strokeWidth="1"
                onClick={() =>
                  showData({
                    "County Name": "Rich County",
                    "No: of Housing Units (Owner Occupied)": "657",
                    "Median Home Value": "$695K",
                    "04-2024": "$760,000",
                    "04-2025": "$579,000",
                    "Increase/Decrease": "-23.8%",
                    "2024 YTD": "$445,000",
                    "2025 YTD": "$683,000",
                    "Increase/DecreaseYTD": "53.5%",
                    Color: "#F4C2C2",
                  })
                }
                stroke="black"
                fill={countyname === "Rich County" ? "#F4C2C280" : "#F4C2C2"}
              ></path>
            </OverlayTrigger>
            <OverlayTrigger
              placement="right"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip14}
            >
              <path
                id="49017"
                className="county"
                d="M146.969,319.282L149.151,319.073L162.374,319.073L173.438,319.133L173.438,319.432L180.38,319.395L180.374,318.988L187.233,318.972L200.412,318.98L200.412,319.065L214.417,319.069L214.427,318.754L228.825,318.887L229.781,318.871L251.664,318.916L308.585,318.924L308.251,320.177L306.883,320.617L306.324,321.947L305.419,322.289L304.968,322.958L304.279,323.059L303.783,322.394L302.964,322.607L302.332,323.357L301.033,325.467L301.284,326.241L300.989,327.223L299.852,327.871L299.214,329.292L299.414,330.596L299.115,331.24L298.153,331.573L296.835,330.479L295.361,330.712L294.803,331.899L293.85,332.519L293.57,333.681L292.135,334.94L291.198,335.442L291.011,336.668L291.446,337.77L290.674,339.739L288.537,339.514L287.349,339.24L286.52,339.895L286.432,341.494L286.003,341.904L285.539,341.622L285.333,340.309L284.698,339.943L280.947,339.811L279.432,340.152L278.384,340.795L278.527,343.016L277.311,343.662L276.501,344.814L276.298,346.653L275.371,346.404L274.135,346.524L273.827,347.138L274.297,348.915L274.678,349.457L276.99,349.124L275.676,350.732L275.682,352.264L274.361,353.234L274.237,354.204L273.17,354.937L273.392,355.486L273.256,357.205L272.776,357.793L272.239,359.223L271.636,358.683L270.909,359.143L270.325,360.344L269.724,360.548L268.845,359.836L268.292,360.476L268.14,361.953L266.311,362.734L265.939,363.094L266.047,364.69L265.777,365.519L265.158,366.07L263.837,366.758L263.065,367.934L256.456,367.978L240.613,367.958L239.892,368.002L208.053,368.05L187.383,368.042L187.386,368.354L166.849,368.346L166.849,368.274L154.403,368.306L154.413,367.77L152.203,367.79L135.032,367.77L133.974,367.722L133.984,360.677L133.816,358.274L133.847,353.831L133.641,353.843L133.628,346.757L136.531,346.669L140.64,346.841L140.65,340.614L140.011,340.61L140.015,339.951L147.633,339.947L147.709,332.941L146.95,332.941Z"
                data-item='{"area":13403500715,"county":{"year":2024,"fips":49017,"pop2020":5103,"pop2024":5370,"state":"Utah","stateCode":"UT","growthSince2020":0.05232216343327445,"name":"Garfield County","county":"Garfield County","slug":"utah/garfield-county","landArea":5180,"density":1.0366795366795367,"rank":25,"densityMi":1.0366795366795367,"areaMi":5180}}'
                strokeWidth="1"
                onClick={() =>
                  showData({
                    "County Name": "Garfield County",
                    "No: of Housing Units (Owner Occupied)": "1,490",
                    "Median Home Value": "$595K",
                    "04-2024": "$148,500",
                    "04-2025": "$399,300",
                    "Increase/Decrease": "168.9%",
                    "2024 YTD": "$335,000",
                    "2025 YTD": "$412,600",
                    "Increase/DecreaseYTD": "23.2%",
                    Color: "#E6E6FA",
                  })
                }
                stroke="black"
                fill={
                  countyname === "Garfield County" ? "#E6E6FA80" : "#E6E6FA"
                }
              ></path>
            </OverlayTrigger>
            <OverlayTrigger
              placement="left"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip15}
            >
              <path
                id="49009"
                className="county"
                d="M303.977,84.96L305.571,84.91L313.19,84.935L324.524,84.872L333.488,84.893L335.657,84.809L351.494,84.654L352.685,84.565L356.379,84.666L364.21,84.683L364.311,99.32L364.273,108.647L364.318,112.992L359.561,113.008L359.561,111.194L357.179,111.219L357.131,103.881L357.026,102.68L354.622,102.684L354.505,96.613L342.387,96.63L342.39,102.252L341.091,102.604L339.862,103.421L339.43,104.404L339.722,105.041L338.468,105.363L337.617,105.254L337.334,106.196L336.702,106.484L334.66,105.292L334.705,103.404L334.498,102.985L334.975,101.959L334.816,100.833L333.847,99.191L331.148,100.38L330.595,99.379L329.217,100.242L328.515,99.991L328.128,100.422L327.331,100.192L326.188,101.046L326.019,101.524L325.365,101.444L324.501,101.93L322.993,101.214L321.764,101.348L321.246,101.917L319.817,101.281L318.931,102.964L317.343,102.985L314.673,103.534L314.53,104.162L312.246,104.53L311.43,103.605L310.776,103.768L310.56,103.01L309.687,103.061L309.176,102.265L308.318,101.788L307.734,101.917L305.517,100.69L304.79,100.866L304.422,100.229L303.977,100.355Z"
                data-item='{"area":1804943545,"county":{"year":2024,"fips":49009,"pop2020":952,"pop2024":969,"state":"Utah","stateCode":"UT","growthSince2020":0.017857142857142794,"name":"Daggett County","county":"Daggett County","slug":"utah/daggett-county","landArea":697,"density":1.3902439024390243,"rank":29,"densityMi":1.3902439024390243,"areaMi":697}}'
                strokeWidth="1"
                onClick={() =>
                  showData({
                    "County Name": "Daggett County",
                    "No: of Housing Units (Owner Occupied)": "1,147",
                    "Median Home Value": "$574.9K",
                    "04-2024": "--",
                    "04-2025": "$230,000",
                    "Increase/Decrease": "--",
                    "2024 YTD": "$265,000",
                    "2025 YTD": "$332,500",
                    "Increase/DecreaseYTD": "25.5%",
                    Color: "#99CCFF",
                  })
                }
                stroke="black"
                fill={countyname === "Daggett County" ? "#99CCFF80" : "#99CCFF"}
              ></path>
              {/* Add similar <path> elements for all counties in Utah */}
            </OverlayTrigger>
            <OverlayTrigger
              placement="right"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip16}
            >
              <path
                id="49021"
                className="county"
                d="M47.412,319.174L72.211,319.174L97.708,319.178L125.53,319.274L133.247,319.274L138.385,319.23L146.969,319.282L146.95,332.941L147.709,332.941L147.633,339.947L140.015,339.951L140.011,340.61L140.65,340.614L140.64,346.841L136.531,346.669L133.628,346.757L133.641,353.843L133.847,353.831L133.816,358.274L133.984,360.677L133.974,367.722L120.198,367.742L120.208,371.212L111.586,371.236L111.589,373.254L104.679,373.266L104.679,372.73L100.189,372.73L97.874,372.638L97.883,368.898L83.901,368.89L83.872,361.761L76.695,361.765L76.692,362.854L47.25,362.842L47.298,351.534L47.504,346.416L47.428,345.312L47.381,331.151Z"
                data-item='{"area":8537573733,"county":{"year":2024,"fips":49021,"pop2020":57713,"pop2024":65914,"state":"Utah","stateCode":"UT","growthSince2020":0.14209970024084706,"name":"Iron County","county":"Iron County","slug":"utah/iron-county","landArea":3296,"density":19.998179611650485,"rank":8,"densityMi":19.998179611650485,"areaMi":3296}}'
                strokeWidth="1"
                onClick={() =>
                  showData({
                    "County Name": "Iron County",
                    "No: of Housing Units (Owner Occupied)": "13,255",
                    "Median Home Value": "$450K",
                    "04-2024": "$375,000",
                    "04-2025": "$416,450",
                    "Increase/Decrease": "11.1%",
                    "2024 YTD": "$385,000",
                    "2025 YTD": "$400,000",
                    "Increase/DecreaseYTD": "3.9%",
                    Color: "#507882",
                  })
                }
                stroke="black"
                fill={countyname === "Iron County" ? "#50788280" : "#507882"}
              ></path>
            </OverlayTrigger>
            <OverlayTrigger
              placement="right"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip17}
            >
              <path
                id="49027"
                className="county"
                d="M47.549,205.762L62.249,205.651L62.249,204.948L118.788,204.956L137.411,204.969L147.998,204.964L147.998,204.862L162.346,204.866L163.864,204.837L164.458,205.951L165.051,205.947L165.055,207.135L163.867,207.131L163.867,208.319L164.458,208.915L164.458,210.106L165.051,210.106L165.032,219.682L165.328,219.682L165.328,223.266L172.73,223.237L172.721,224.45L176.284,224.479L176.404,246.471L176.411,248.201L176.093,248.209L176.1,250.515L173.724,250.535L173.724,251.13L173.137,251.126L173.168,253.5L168.815,253.5L168.805,255.444L167.671,255.44L167.744,257.8L166.566,257.832L166.427,260.069L165.356,260.003L165.35,261.197L163.076,261.197L163.063,263.415L162.822,263.415L162.828,269.391L163.413,269.391L163.464,272.367L162.305,272.391L161.996,273.574L161.117,273.59L161.114,274.179L159.98,274.183L159.408,274.467L159.415,275.658L158.84,275.946L157.659,275.938L157.659,276.515L154.702,276.478L154.708,275.901L151.879,276.133L148.941,276.113L148.932,276.705L147.773,276.705L147.76,277.895L147.179,277.895L147.188,279.081L146.604,279.081L146.582,282.652L145.423,282.656L145.416,285.024L144.641,284.903L129.617,284.919L110.945,284.923L101.824,284.923L47.396,284.895L47.422,272.216L47.46,270.534L47.441,260.37L47.53,260.064L47.463,249.731L47.59,209.276Z"
                data-item='{"area":17106720226,"county":{"year":2024,"fips":49027,"pop2020":13060,"pop2024":13531,"state":"Utah","stateCode":"UT","growthSince2020":0.03606431852986214,"name":"Millard County","county":"Millard County","slug":"utah/millard-county","landArea":6785,"density":1.9942520265291084,"rank":18,"densityMi":1.9942520265291084,"areaMi":6785}}'
                strokeWidth="1"
                onClick={() =>
                  showData({
                    "County Name": "Millard County",
                    "No: of Housing Units (Owner Occupied)": "3,346",
                    "Median Home Value": "$394.3K",
                    "04-2024": "$272,000",
                    "04-2025": "$269,000",
                    "Increase/Decrease": "-1.1%",
                    "2024 YTD": "$296,000",
                    "2025 YTD": "$340,500",
                    "Increase/DecreaseYTD": "15.0%",
                    Color: "#FF91A4",
                  })
                }
                stroke="black"
                fill={countyname === "Millard County" ? "#FF91A480" : "#FF91A4"}
              ></path>
            </OverlayTrigger>
            <OverlayTrigger
              placement="right"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip18}
            >
              <path
                id="49041"
                className="county"
                d="M144.641,284.903L145.416,285.024L145.423,282.656L146.582,282.652L146.604,279.081L147.188,279.081L147.179,277.895L147.76,277.895L147.773,276.705L148.932,276.705L148.941,276.113L151.879,276.133L154.708,275.901L154.702,276.478L157.659,276.515L157.659,275.938L158.84,275.946L159.415,275.658L159.408,274.467L159.98,274.183L161.114,274.179L161.117,273.59L161.996,273.574L162.305,272.391L163.464,272.367L163.413,269.391L162.828,269.391L162.822,263.415L163.063,263.415L163.076,261.197L165.35,261.197L165.356,260.003L166.427,260.069L166.566,257.832L167.744,257.8L167.671,255.44L168.805,255.444L168.815,253.5L173.168,253.5L173.137,251.126L173.724,251.13L173.724,250.535L176.1,250.515L176.093,248.209L176.411,248.201L176.404,246.471L186.808,246.466L186.586,247.462L199.552,247.544L221.693,247.552L221.766,248.732L221.705,276.835L221.207,276.835L221.21,283.869L221.305,283.869L221.292,289.982L210.67,289.99L192.74,289.982L192.099,290.622L173.372,290.634L173.362,289.957L164.292,289.82L159.024,289.884L144.445,289.961L144.187,289.078L144.616,288.324L144.499,287.064Z"
                data-item='{"area":4948102439,"county":{"year":2024,"fips":49041,"pop2020":21554,"pop2024":22645,"state":"Utah","stateCode":"UT","growthSince2020":0.050617054839009024,"name":"Sevier County","county":"Sevier County","slug":"utah/sevier-county","landArea":1910,"density":11.856020942408376,"rank":14,"densityMi":11.856020942408376,"areaMi":1910}}'
                strokeWidth="1"
                onClick={() =>
                  showData({
                    "County Name": "Sevier County",
                    "No: of Housing Units (Owner Occupied)": "5,906",
                    "Median Home Value": "$399.9K",
                    "04-2024": "$310,000",
                    "04-2025": "$322,500",
                    "Increase/Decrease": "4.0%",
                    "2024 YTD": "$306,000",
                    "2025 YTD": "$322,500",
                    "Increase/DecreaseYTD": "5.4%",
                    Color: "#98FF98",
                  })
                }
                stroke="black"
                fill={countyname === "Sevier County" ? "#98FF9880" : "#98FF98"}
              ></path>
            </OverlayTrigger>
            <OverlayTrigger
              placement="right"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip19}
            >
              <path
                id="49013"
                className="county"
                d="M303.977,100.355L304.422,100.229L304.79,100.866L305.517,100.69L305.492,184.071L300.011,184.063L271.188,184.03L271.188,183.625L254.596,183.53L249.67,183.489L249.68,176.357L247.523,176.361L247.517,161.244L247.231,161.248L247.209,151.614L247.212,132.288L246.809,132.284L246.869,111.692L247.39,111.558L246.777,110.069L246.729,109.329L247.136,108.748L247.936,108.488L247.504,107.597L248.562,107.497L249.368,108.058L250.324,107.752L251.849,108.99L252.906,108.898L253.729,108.275L254.395,107.279L255.536,106.769L255.462,106.405L256.466,105.89L256.942,106.129L258.295,106.066L258.927,105.459L260.267,106.397L261.204,106.606L262.427,106.497L263.865,104.396L264.389,104.053L265.536,104.97L266.345,105.028L267.07,104.622L267.486,105.074L268.451,104.986L269.258,103.73L270.217,103.923L270.852,104.723L272.478,104.124L273.157,103.153L274.075,103.86L275.053,102.906L276.628,103.299L277.165,102.181L277.978,102.818L278.931,102.449L280.01,102.575L281.516,101.494L281.919,100.745L281.773,100.183L282.322,99.538L283.275,99.869L284.923,99.291L285.476,98.709L286.12,99.149L287.486,98.587L288.928,99.14L289.487,98.922L290.979,99.618L292.122,99.312L293.177,100.1L293.961,99.744L295.288,100.59L296.006,100.25L297.518,100.841L299.233,100.661L299.941,100.313L300.725,100.472L301.316,99.773L302.427,99.785L303.005,100.288Z"
                data-item='{"area":8379461042,"county":{"year":2024,"fips":49013,"pop2020":19620,"pop2024":20812,"state":"Utah","stateCode":"UT","growthSince2020":0.06075433231396543,"name":"Duchesne County","county":"Duchesne County","slug":"utah/duchesne-county","landArea":3236,"density":6.431396786155748,"rank":15,"densityMi":6.431396786155748,"areaMi":3236}}'
                strokeWidth="1"
                onClick={() =>
                  showData({
                    "County Name": "Duchesne County",
                    "No: of Housing Units (Owner Occupied)": "5,324",
                    "Median Home Value": "$382.4K",
                    "04-2024": "$349,450",
                    "04-2025": "$273,000",
                    "Increase/Decrease": "-21.9%",
                    "2024 YTD": "$344,500",
                    "2025 YTD": "$317,550",
                    "Increase/DecreaseYTD": "-7.8%",
                    Color: "#FFB6C1",
                  })
                }
                stroke="black"
                fill={
                  countyname === "Duchesne County" ? "#FFB6C180" : "#FFB6C1"
                }
              ></path>
            </OverlayTrigger>
            <OverlayTrigger
              placement="left"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip20}
            >
              <path
                id="49037"
                className="county"
                d="M214.506,410.898L214.83,410.632L217.374,410.847L218.841,410.303L219.663,409.417L220.711,410.052L221.426,409.786L221.188,409.032L222.718,407.932L222.636,407.487L221.826,407.574L221.365,407.006L221.327,406.097L221.785,405.739L222.521,406.287L223.693,406.76L224.979,409.302L225.726,408.901L225.954,407.634L225.087,407.4L224.935,406.971L225.516,405.525L225.884,405.485L226.348,406.466L226.932,406.446L228.831,403.915L229.359,402.87L230.219,402.655L231.01,403.712L232.159,403.792L232.998,402.436L234.198,402.85L235.926,402.802L236.501,402.444L237.006,403.124L237.638,403.064L238.171,402.357L239.365,402.158L239.791,401.828L241.14,402.194L241.731,401.924L241.874,400.85L243.096,401.224L243.786,400.297L243.43,399.299L243.84,398.893L244.694,399.227L245.151,398.412L245.612,396.828L247.025,397.023L247.06,396.168L247.723,394.85L247.234,394.106L247.419,393.676L248.536,392.94L248.266,391.837L247.844,391.375L248.136,390.909L249.219,390.63L249.454,389.992L248.676,388.984L248.663,388.203L250.454,387.685L250.975,387.223L250.759,385.669L249.175,385.015L248.663,383.958L248.908,383.288L249.867,383.36L252.541,385.174L253.287,385.469L254.738,385.334L255.285,384.648L256.088,384.369L256.456,382.997L257.381,383.567L257.47,382.459L258.254,381.334L257.095,380.384L256.31,379.299L256.368,378.716L257.279,378.724L258.26,379.251L259.232,378.193L259.718,376.748L259.508,376.341L258.054,376.357L256.755,374.991L256.949,374.352L258.009,374.448L258.152,373.094L258.451,372.702L259.889,372.686L261.449,373.014L263.414,372.399L262.976,371.719L261.861,371.647L261.858,370.329L262.227,369.033L263.065,367.934L263.837,366.758L265.158,366.07L265.777,365.519L266.047,364.69L265.939,363.094L266.311,362.734L268.14,361.953L268.292,360.476L268.845,359.836L269.724,360.548L270.325,360.344L270.909,359.143L271.636,358.683L272.239,359.223L272.776,357.793L273.256,357.205L273.392,355.486L273.17,354.937L274.237,354.204L274.361,353.234L275.682,352.264L275.676,350.732L276.99,349.124L274.678,349.457L274.297,348.915L273.827,347.138L274.135,346.524L275.371,346.404L276.298,346.653L276.501,344.814L277.311,343.662L278.527,343.016L278.384,340.795L279.432,340.152L280.947,339.811L284.698,339.943L285.333,340.309L285.539,341.622L286.003,341.904L286.432,341.494L286.52,339.895L287.349,339.24L288.537,339.514L290.674,339.739L291.446,337.77L291.011,336.668L291.198,335.442L292.135,334.94L293.57,333.681L293.85,332.519L294.803,331.899L295.361,330.712L296.835,330.479L298.153,331.573L299.115,331.24L299.414,330.596L299.214,329.292L299.852,327.871L300.989,327.223L301.284,326.241L301.033,325.467L302.332,323.357L302.964,322.607L303.783,322.394L304.279,323.059L304.968,322.958L305.419,322.289L306.324,321.947L306.883,320.617L308.251,320.177L308.585,318.924L308.385,318.424L309.128,317.98L310.201,316.742L310.929,316.589L311.164,315.831L310.268,316.016L310.144,315.613L311.116,314.439L310.427,314.491L309.249,313.805L309.109,313.095L309.646,312.772L310.779,312.804L311.049,312.506L310.398,311.606L309.484,311.912L309.277,311.275L310.217,310.532L309.795,309.296L308.683,310.205L308.077,309.744L308.56,308.917L308.331,308.246L307.321,307.858L307.432,306.424L306.502,305.58L306.222,304.606L307.156,304L307.759,302.884L307.035,302.585L306.895,303.349L306.07,303.648L304.882,302.338L305.733,300.842L305.374,299.782L304.777,300.049L303.977,301.271L303.434,301.724L303.18,300.482L301.995,300.11L302.958,298.451L303.806,297.586L302.313,295.064L301.421,295.117L301.338,294.271L301.837,294.048L302.716,295.088L303.32,294.927L303.288,294.141L303.745,293.356L303.898,292.343L302.411,290.808L326.07,290.812L343.625,290.808L363.584,290.804L363.578,308.953L364.737,317.891L364.651,333.215L364.781,338.601L364.731,341.365L364.756,347.198L364.705,357.938L364.731,368.762L364.651,371.216L364.48,381.19L364.467,396.932L364.521,402.118L364.518,411.089L343.428,411.085L335.997,411.085L327.741,411.148L311.9,411.132L303.977,411.176L302.64,411.124L286.539,411.152L274.231,411.172L272.297,410.676L266.034,410.739L236.856,410.823L232.188,410.954L224.513,410.93L223.026,410.978Z"
                data-item='{"area":20253930400,"county":{"year":2024,"fips":49037,"pop2020":14521,"pop2024":14310,"state":"Utah","stateCode":"UT","growthSince2020":-0.014530679705254457,"name":"San Juan County","county":"San Juan County","slug":"utah/san-juan-county","landArea":7824,"density":1.8289877300613497,"rank":17,"densityMi":1.8289877300613497,"areaMi":7824}}'
                strokeWidth="1"
                onClick={() =>
                  showData({
                    "County Name": "San Juan County",
                    "No: of Housing Units (Owner Occupied)": "3,712",
                    "Median Home Value": "$522K",
                    "04-2024": "$329,000",
                    "04-2025": "$327,200",
                    "Increase/Decrease": "-0.5%",
                    "2024 YTD": "$470,000",
                    "2025 YTD": "$447,450",
                    "Increase/DecreaseYTD": "-4.8%",
                    Color: "#AFB3CE",
                  })
                }
                stroke="black"
                fill={
                  countyname === "San Juan County" ? "#AFB3CE80" : "#AFB3CE"
                }
              ></path>
            </OverlayTrigger>
            <OverlayTrigger
              placement="right"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip21}
            >
              <path
                id="49031"
                className="county"
                d="M144.445,289.961L159.024,289.884L164.292,289.82L173.362,289.957L173.372,290.634L192.099,290.622L188.478,294.267L188.183,295.424L187.589,296.59L186.881,296.882L187.106,307.22L187.233,318.972L180.374,318.988L180.38,319.395L173.438,319.432L173.438,319.133L162.374,319.073L149.151,319.073L149.821,318.795L149.742,317.976L150.529,317.395L150.415,316.581L152.088,315.096L152.266,314.56L154.175,313.825L154.664,313.022L154.283,312.861L153.225,311.452L153.168,310.96L153.978,310.181L154.33,309.207L155.077,308.444L155.305,307.701L155.216,306.562L155.836,305.976L155.702,304.913L156.039,304.363L155.534,303.159L154.435,302.544L154.292,301.982L153.2,300.523L152.485,300.458L151.714,299.321L152.031,298.65L151.761,297.634L150.888,297.315L150.335,298.346L149.646,298.731L149.138,298.407L148.595,296.533L146.934,295.012L146.036,294.72L145.496,293.546L144.988,293.416L144.413,292.323L144.978,291.715L144.426,290.804Z"
                data-item='{"area":1964346244,"county":{"year":2024,"fips":49031,"pop2020":1440,"pop2024":1607,"state":"Utah","stateCode":"UT","growthSince2020":0.11597222222222214,"name":"Piute County","county":"Piute County","slug":"utah/piute-county","landArea":758,"density":2.120052770448549,"rank":28,"densityMi":2.120052770448549,"areaMi":758}}'
                strokeWidth="1"
                onClick={() =>
                  showData({
                    "County Name": "Piute County",
                    "No: of Housing Units (Owner Occupied)": "525",
                    "Median Home Value": "$427.5K",
                    "04-2024": "--",
                    "04-2025": "--",
                    "Increase/Decrease": "--",
                    "2024 YTD": "$356,000",
                    "2025 YTD": "$261,111",
                    "Increase/DecreaseYTD": "-26.7%",
                    Color: "#ADD8E6",
                  })
                }
                stroke="black"
                fill={countyname === "Piute County" ? "#ADD8E680" : "#ADD8E6"}
              ></path>
            </OverlayTrigger>
            <OverlayTrigger
              placement="right"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip22}
            >
              <path
                id="49055"
                className="county"
                d="M192.099,290.622L192.74,289.982L210.67,289.99L221.292,289.982L221.289,290.804L251.213,290.808L302.411,290.808L303.898,292.343L303.745,293.356L303.288,294.141L303.32,294.927L302.716,295.088L301.837,294.048L301.338,294.271L301.421,295.117L302.313,295.064L303.806,297.586L302.958,298.451L301.995,300.11L303.18,300.482L303.434,301.724L303.977,301.271L304.777,300.049L305.374,299.782L305.733,300.842L304.882,302.338L306.07,303.648L306.895,303.349L307.035,302.585L307.759,302.884L307.156,304L306.222,304.606L306.502,305.58L307.432,306.424L307.321,307.858L308.331,308.246L308.56,308.917L308.077,309.744L308.683,310.205L309.795,309.296L310.217,310.532L309.277,311.275L309.484,311.912L310.398,311.606L311.049,312.506L310.779,312.804L309.646,312.772L309.109,313.095L309.249,313.805L310.427,314.491L311.116,314.439L310.144,315.613L310.268,316.016L311.164,315.831L310.929,316.589L310.201,316.742L309.128,317.98L308.385,318.424L308.585,318.924L251.664,318.916L229.781,318.871L228.825,318.887L214.427,318.754L214.417,319.069L200.412,319.065L200.412,318.98L187.233,318.972L187.106,307.22L186.881,296.882L187.589,296.59L188.183,295.424L188.478,294.267Z"
                data-item='{"area":6374186210,"county":{"year":2024,"fips":49055,"pop2020":2503,"pop2024":2594,"state":"Utah","stateCode":"UT","growthSince2020":0.036356372353176125,"name":"Wayne County","county":"Wayne County","slug":"utah/wayne-county","landArea":2461,"density":1.0540430719219829,"rank":27,"densityMi":1.0540430719219829,"areaMi":2461}}'
                strokeWidth="1"
                onClick={() =>
                  showData({
                    "County Name": "Wayne County",
                    "No: of Housing Units (Owner Occupied)": "822",
                    "Median Home Value": "$899K",
                    "04-2024": "$367,500",
                    "04-2025": "$380,000",
                    "Increase/Decrease": "3.4%",
                    "2024 YTD": "$432,500",
                    "2025 YTD": "$420,000",
                    "Increase/DecreaseYTD": "-2.9%",
                    Color: "#C4A484",
                  })
                }
                stroke="black"
                fill={countyname === "Wayne County" ? "#C4A48480" : "#C4A484"}
              ></path>
            </OverlayTrigger>
            {/* <Link to="/utah-at-a-glance/counties/cache-county"> */}
            <OverlayTrigger
              placement="right"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip23}
            >
              <path
                id="49005"
                className="county"
                d="M166.862,0.414L176.525,0.273L185.125,0.26L193.089,0.192L208.485,0.175L208.472,1.182L209.136,1.403L209.971,2.235L209.974,3.032L210.508,3.745L210.673,4.61L210.47,5.671L210.797,6.255L209.917,7.746L208.815,7.491L208.259,8.215L208.955,8.803L208.803,9.701L209.38,9.748L209.349,10.898L208.39,11.311L208.857,11.975L208.482,12.686L211.06,15.15L211.467,15.716L212.089,17.77L211.851,18.897L212.559,19.564L212.715,20.916L212.648,22.59L214.03,23.563L214.23,24.582L213.614,27.529L214.335,27.677L214.436,28.501L214.868,28.475L215.214,29.549L214.261,30.805L214.639,31.806L213.423,32.591L213.601,35.355L213.217,38.058L212.451,38.846L212.594,39.943L211.705,39.871L211.743,40.829L211.06,41.815L210.368,42.264L210.565,43.03L209.622,45.442L208.93,45.607L208.625,47.426L208.93,47.874L208.291,49.101L206.961,49.824L206.23,50.597L205.554,49.071L204.881,49.101L204.198,48.623L203.664,49.498L201.438,49.185L200.117,49.815L199.866,50.538L199.307,50.394L198.402,48.619L197.634,48.745L196.529,49.608L195.814,48.902L194.947,48.741L195.119,49.612L195.878,49.98L195.893,50.644L194.604,52.313L194.626,53.095L193.372,53.602L192.089,53.585L190.133,51.7L189.075,52.068L188.205,51.675L187.348,51.785L185.63,51.18L184.934,49.68L185.392,49.249L184.556,48.822L184.801,47.57L184.201,47.536L183.626,46.517L182.584,45.95L182.816,45.154L183.874,45.176L185.007,44.778L185.325,43.805L184.639,42.937L183.305,42.865L182.775,39.922L182.352,39.295L181.52,39.088L181.308,38.308L180.714,38.109L179.707,38.91L179.037,38.91L178.45,39.71L177.757,37.944L176.82,34.041L177.065,33.07L176.849,31.802L176.316,30.588L176.49,30.058L176.147,28.832L175.341,27.194L174.442,26.769L174.013,25.64L174.591,24.744L174.512,22.658L175.153,21.438L175.169,20.202L175.626,19.164L176.376,18.803L176.751,17.617L176.144,16.77L175.366,16.307L175.452,15.388L175.093,15.124L174.372,13.584L173.95,11.528L173.245,11.379L173.261,10.774L171.882,8.373L170.634,7.729L169.574,6.255L169.418,5.168L168.51,3.177L167.738,2.644L167.551,1.412Z"
                data-item='{"area":3016617785,"county":{"year":2024,"fips":49005,"pop2020":133631,"pop2024":144641,"state":"Utah","stateCode":"UT","growthSince2020":0.08239106195418722,"name":"Cache County","county":"Cache County","slug":"utah/cache-county","landArea":1165,"density":124.15536480686696,"rank":6,"densityMi":124.15536480686696,"areaMi":1165}}'
                strokeWidth="1"
                onClick={() =>
                  showData({
                    "County Name": "Cache County",
                    "No: of Housing Units (Owner Occupied)": "27,431",
                    "Median Home Value": "$500K",
                    "04-2024": "$419,900",
                    "04-2025": "$414,500",
                    "Increase/Decrease": "-1.3%",
                    "2024 YTD": "$422,500",
                    "2025 YTD": "$420,000",
                    "Increase/DecreaseYTD": "-0.6%",
                    Color: "#FDFD96",
                  })
                }
                stroke="black"
                fill={countyname === "Cache County" ? "#FDFD9680" : "#FDFD96"}
              ></path>
            </OverlayTrigger>
            {/* </Link> */}
            <OverlayTrigger
              placement="right"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip24}
            >
              <path
                id="49053"
                className="county"
                d="M47.25,362.842L76.692,362.854L76.695,361.765L83.872,361.761L83.901,368.89L97.883,368.898L97.874,372.638L100.189,372.73L104.679,372.73L104.679,373.266L111.589,373.254L111.586,371.236L120.208,371.212L120.192,388.646L120.325,388.646L120.322,410.989L108.874,411.001L96.54,411.005L74.498,411.009L52.735,411.017L47.368,410.981L47.292,403.792L47.317,392.434L47.295,377.754L47.25,376.688L47.219,363.798Z"
                data-item='{"area":6285672118,"county":{"year":2024,"fips":49053,"pop2020":182015,"pop2024":207174,"state":"Utah","stateCode":"UT","growthSince2020":0.13822487157651842,"name":"Washington County","county":"Washington County","slug":"utah/washington-county","landArea":2428,"density":85.32701812191104,"rank":5,"densityMi":85.32701812191104,"areaMi":2428}}'
                strokeWidth="1"
                onClick={() =>
                  showData({
                    "County Name": "Washington County",
                    "No: of Housing Units (Owner Occupied)": "48,574",
                    "Median Home Value": "$600K",
                    "04-2024": "$540,138",
                    "04-2025": "$510,000",
                    "Increase/Decrease": "-5.6%",
                    "2024 YTD": "$523,500",
                    "2025 YTD": "$520,000",
                    "Increase/DecreaseYTD": "-0.7%",
                    Color: "#FF69B4",
                  })
                }
                stroke="black"
                fill={
                  countyname === "Washington County" ? "#FF69B480" : "#FF69B4"
                }
              ></path>
            </OverlayTrigger>
            <OverlayTrigger
              placement="right"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip25}
            >
              <path
                id="49039"
                className="county"
                d="M199.984,183.522L207.186,183.514L207.183,183.592L221.219,183.563L224.976,183.51L224.986,192.467L224.989,202.505L224.96,211.963L221.594,211.963L221.607,226.122L221.667,226.118L221.667,240.569L221.693,247.552L199.552,247.544L186.586,247.462L186.808,246.466L176.404,246.471L176.284,224.479L176.296,222.651L179.952,222.655L179.91,220.252L182.26,220.195L182.216,218.985L193.324,218.891L193.283,212.55L195.468,212.529L195.465,205.318L195.309,205.314L195.344,198.011L195.214,198.011L195.198,193.271L196.973,193.217L196.967,191.973L197.558,191.985L197.551,191.387L198.755,191.371L198.755,190.761L199.942,190.753L199.949,189.553L203.607,189.52L203.601,185.882L201.216,185.92L201.241,184.711L199.977,184.723Z"
                data-item='{"area":4117768225,"county":{"year":2024,"fips":49039,"pop2020":28526,"pop2024":30863,"state":"Utah","stateCode":"UT","growthSince2020":0.08192526116525278,"name":"Sanpete County","county":"Sanpete County","slug":"utah/sanpete-county","landArea":1590,"density":19.41069182389937,"rank":13,"densityMi":19.41069182389937,"areaMi":1590}}'
                strokeWidth="1"
                onClick={() =>
                  showData({
                    "County Name": "Sanpete County",
                    "No: of Housing Units (Owner Occupied)": "6,691",
                    "Median Home Value": "$488K",
                    "04-2024": "$370,000",
                    "04-2025": "$399,000",
                    "Increase/Decrease": "7.8%",
                    "2024 YTD": "$342,000",
                    "2025 YTD": "$400,000",
                    "Increase/DecreaseYTD": "17.0%",
                    Color: "#E6A8D7",
                  })
                }
                stroke="black"
                fill={countyname === "Sanpete County" ? "#E6A8D780" : "#E6A8D7"}
              ></path>
            </OverlayTrigger>
            <OverlayTrigger
              placement="right"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip26}
            >
              <path
                id="49015"
                className="county"
                d="M221.693,247.552L221.667,240.569L221.667,226.118L221.607,226.122L221.594,211.963L224.96,211.963L224.989,202.505L224.986,192.467L226.081,192.863L226.643,193.584L226.615,194.857L227.904,196.356L227.863,197.307L228.45,197.653L228.86,199.452L229.501,199.876L229.857,200.777L230.578,201.386L231.267,201.028L231.931,199.802L232.337,200.477L233.106,203.398L233.287,205.01L233.912,205.45L233.852,206.144L234.379,206.268L235.24,207.476L235.58,209.654L235.926,209.999L235.745,211.757L255.99,211.79L272.506,211.766L302.494,211.794L302.97,212.804L302.564,213.679L302.707,215.14L302.535,215.584L303.348,216.138L302.681,218.288L302.812,219.207L302.43,219.321L302.764,220.543L302.618,221.409L301.862,221.659L301.802,222.335L300.719,223.569L300.249,225.061L300.874,225.626L299.757,226.175L299.125,227.645L300.049,228.395L299.992,229.767L300.563,231.539L299.906,231.948L299.09,231.711L299.369,233.769L299.026,234.383L297.762,234.71L297.349,235.63L297.781,236.403L296.908,237.082L296.66,237.732L297.721,239.061L297.038,239.453L296.746,240.32L297.092,240.965L296.571,242.35L295.222,242.93L294.812,243.87L295.142,244.392L295.158,245.478L294.123,247.52L295.133,248.111L294.282,248.989L295.279,249.846L294.501,250.009L294.507,250.408L295.533,250.641L295.536,250.041L297.918,250.045L297.918,251.302L300.233,251.302L300.233,250.71L301.411,250.71L301.411,251.897L302.592,251.897L302.589,253.08L303.771,253.08L303.767,254.266L301.411,254.262L301.411,253.671L300.82,253.671L300.82,253.08L299.642,253.08L299.642,251.897L294.495,251.828L294.561,252.472L295.288,253.426L294.348,254.283L295.05,254.654L295.485,255.591L295.123,256.349L293.256,256.125L292.824,256.353L292.662,257.739L293.561,258.411L293.894,259.05L293.723,261.266L294.428,261.311L294.977,260.822L295.409,261.526L294.771,262.967L295.355,263.643L296.057,263.729L296.457,264.229L296.181,264.799L296.819,264.937L297.295,265.601L297.273,266.512L296.314,267.081L297.216,268.31L298.283,268.855L298.829,269.989L298.709,270.371L297.632,270.676L296.864,272.021L297.292,273.155L296.444,273.578L296.829,274.061L297.543,273.501L298.267,273.411L298.575,273.915L297.804,274.841L297.823,275.564L298.509,276.49L297.994,277.172L298.401,277.428L299.283,276.762L299.668,277.026L299.553,278.139L300.214,277.688L300.35,278.894L300.741,278.971L301.163,277.879L301.719,278.46L300.887,279.994L301.379,281.118L301.195,281.43L299.874,281.159L299.661,281.645L300.477,282.303L302.713,281.775L302.98,280.822L303.834,281.057L304.215,281.986L304.256,283.134L303.199,283.751L302.402,282.704L301.856,282.372L300.354,284.023L300.509,284.493L301.214,284.538L301.849,285.028L302.418,284.55L302.862,285.645L303.253,285.856L303.977,285.357L304.774,285.86L303.679,287.258L304.384,288.608L303.977,289.042L303.186,288.823L303.024,289.674L301.662,289.297L301.132,289.621L301.433,290.383L302.411,290.808L251.213,290.808L221.289,290.804L221.292,289.982L221.305,283.869L221.21,283.869L221.207,276.835L221.705,276.835L221.766,248.732Z"
                data-item='{"area":11557280470,"county":{"year":2024,"fips":49015,"pop2020":9847,"pop2024":10195,"state":"Utah","stateCode":"UT","growthSince2020":0.03534071290748453,"name":"Emery County","county":"Emery County","slug":"utah/emery-county","landArea":4463,"density":2.284337889312122,"rank":21,"densityMi":2.284337889312122,"areaMi":4463}}'
                strokeWidth="1"
                onClick={() =>
                  showData({
                    "County Name": "Emery County",
                    "No: of Housing Units (Owner Occupied)": "2,727",
                    "Median Home Value": "$325K",
                    "04-2024": "$218,500",
                    "04-2025": "$275,000",
                    "Increase/Decrease": "25.9%",
                    "2024 YTD": "$235,000",
                    "2025 YTD": "$295,500",
                    "Increase/DecreaseYTD": "25.7%",
                    Color: "#ECFFE8",
                  })
                }
                stroke="black"
                fill={countyname === "Emery County" ? "#ECFFE880" : "#ECFFE8"}
              ></path>
            </OverlayTrigger>
            <OverlayTrigger
              placement="right"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip27}
            >
              <path
                id="49011"
                className="county"
                d="M186.408,73.047L186.865,73.497L187.148,74.503L186.414,75.332L186.906,78.374L186.687,79.139L187.186,80.014L187.472,81.321L187.837,81.628L187.538,82.763L188.145,82.99L188.704,84.196L189.307,84.309L190.412,85.935L191.552,88.152L190.555,88.022L188.993,88.311L189.717,89.713L190.552,90.796L190.384,91.795L191.073,92.055L191.857,94.097L192.391,94.378L191.978,95.427L193.328,95.54L193.852,96.395L191.127,97.824L190.654,97.686L189.691,98.29L189.171,98.147L188.567,98.637L186.57,99.052L185.477,99.685L180.727,99.677L180.908,98.876L180.095,97.389L179.424,96.655L179.669,95.745L179.132,95.083L179.278,94.223L179.92,93.112L179.917,91.295L176.881,91.295L167.903,97.64L160.809,104.091L146.029,78.277L165.477,71.872L179.136,71.906L180.072,72.916L180.914,73.186L182.308,73.081L182.953,73.426L184.277,73.169Z"
                data-item='{"area":774432531,"county":{"year":2024,"fips":49011,"pop2020":363771,"pop2024":376527,"state":"Utah","stateCode":"UT","growthSince2020":0.03506601680727717,"name":"Davis County","county":"Davis County","slug":"utah/davis-county","landArea":325,"density":1158.5446153846153,"rank":3,"densityMi":1158.5446153846153,"areaMi":325}}'
                strokeWidth="1"
                onClick={() =>
                  showData({
                    "County Name": "Davis County",
                    "No: of Housing Units (Owner Occupied)": "88,759",
                    "Median Home Value": "$570K",
                    "04-2024": "$510,000",
                    "04-2025": "$524,838",
                    "Increase/Decrease": "2.9%",
                    "2024 YTD": "$508,250",
                    "2025 YTD": "$519,950",
                    "Increase/DecreaseYTD": "2.3%",
                    Color: "#C3B1E1",
                  })
                }
                stroke="black"
                fill={countyname === "Davis County" ? "#C3B1E180" : "#C3B1E1"}
              ></path>
            </OverlayTrigger>

            <OverlayTrigger
              placement="right"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip28}
            >
              <path
                id="49049"
                className="county"
                d="M166.344,129.301L167.151,129.801L168.195,129.026L168.945,129.518L170.025,130.664L170.209,131.643L171.371,130.901L173.067,131.022L174.315,130.168L174.893,129.51L175.302,130.672L176.271,131.972L176.624,131.789L176.881,132.659L177.767,132.884L178.431,133.7L179.831,133.35L181.66,132.084L183.169,130.414L183.578,129.601L184.118,129.547L185.334,128.468L185.985,129.118L188.939,127.459L189.504,127.451L190.628,126.742L190.739,125.408L192.483,124.119L193.534,124.678L194.017,123.885L194.985,124.457L195.474,123.831L196.427,123.577L197.281,123.948L198.58,123.122L198.723,122.417L199.46,122.296L200.228,120.906L202.273,121.186L202.477,120.343L203.026,120.13L203.874,121.165L204.687,122.621L204.379,123.41L204.557,124.319L204.198,125.191L204.261,127.138L203.995,128.055L202.969,129.247L202.242,129.276L201.314,130.751L201.981,132.309L202.67,131.988L203.07,132.293L203.677,133.813L204.274,133.808L204.277,135.599L205.17,135.898L205.163,137.392L205.478,137.987L207.266,138.071L210.225,138.029L210.781,139.244L211.368,139.252L211.356,139.843L212.912,141.386L211.692,143.136L212.563,144.038L213.182,143.868L213.636,144.283L214.376,144.117L214.658,143.602L215.529,143.835L216.761,143.406L217.802,144.134L219.39,144.209L219.803,144.645L220.273,144.25L221.149,144.533L221.08,145.177L222.02,145.626L222.998,146.619L223.881,147.981L223.328,148.488L223.334,149.676L224.303,151.677L224.951,152.017L226.37,154.208L225.996,155.813L226.351,156.091L226.631,157.713L226.094,159.222L225.789,159.441L225.303,160.958L225.703,162.346L224.868,163.465L225.564,164.86L226.294,165.113L227.621,164.144L228.133,165.486L228.87,166.438L229.451,166.74L230.013,167.779L230.035,168.843L230.511,168.731L231.016,169.302L231.585,169.136L232.439,170.498L233.103,170.7L233.046,171.61L232.318,172.284L233.157,172.739L235.395,172.76L235.434,176.319L247.523,176.402L247.523,176.361L249.68,176.357L249.67,183.489L235.65,183.419L235.65,183.576L224.976,183.51L221.219,183.563L207.183,183.592L207.186,183.514L199.984,183.522L192.842,183.572L192.111,183.708L192.594,182.573L193.242,181.768L193.35,180.463L194.14,180.149L193.902,179.311L192.721,178.369L192.638,177.121L191.956,176.468L191.378,176.394L190.793,175.567L190.841,174.567L190.298,173.757L188.253,172.446L187.897,173.298L187.881,174.306L186.233,175.112L185.776,175.856L184.804,175.72L184.194,176.468L183.035,176.778L182.26,178.439L181.282,180.017L180.574,180.541L180.441,181.747L180.012,181.545L179.523,182.498L179.663,183.258L179.237,183.984L177.938,183.65L177.621,184.463L176.281,185.259L175.639,186.01L174.664,185.948L174.309,186.493L173.267,186.076L172.968,186.452L171.606,186.072L171.768,185.358L172.435,184.574L173.153,182.106L172.533,181.309L172.603,180.665L172.152,179.216L173.55,177.951L173.908,176.877L173.334,175.943L172.149,175.245L171.895,174.224L170.733,173.955L170.803,172.342L171.333,171.83L170.809,171.466L170.336,170.233L168.894,169.931L167.738,168.607L167.157,167.506L165.906,167.1L166.014,165.871L166.401,164.798L165.664,163.129L166.322,162.586L166.147,161.634L166.436,160.983L167.287,160.701L167.738,159.184L166.141,157.236L166.668,155.921L166.274,155.291L167.211,154.569L167.42,153.971L168.065,153.905L167.579,152.98L167.884,151.884L167.135,151.594L167.249,150.95L167.827,150.489L167.341,149.9L166.608,149.896L165.912,148.824L165.925,147.396L165.121,146.145L165.426,143.859L165.128,142.858L164.715,142.621L165.09,141.294L164.861,141.049L166.176,140.217L165.007,138.22L165.34,137.172L164.677,136.335L164.635,134.591L164.966,133.125L164.086,132.243L163.791,131.155L163.851,129.947L164.912,129.697L165.242,129.18Z"
                data-item='{"area":5189230995,"county":{"year":2024,"fips":49049,"pop2020":663595,"pop2024":735656,"state":"Utah","stateCode":"UT","growthSince2020":0.10859183688846352,"name":"Utah County","county":"Utah County","slug":"utah/utah-county","landArea":2004,"density":367.0938123752495,"rank":2,"densityMi":367.0938123752495,"areaMi":2004}}'
                strokeWidth="1"
                onClick={() =>
                  showData({
                    "County Name": "Utah County",
                    "No: of Housing Units (Owner Occupied)": "133,266",
                    "Median Home Value": "$579.5K",
                    "04-2024": "$489,059",
                    "04-2025": "$499,990",
                    "Increase/Decrease": "1.8%",
                    "2024 YTD": "$499,900",
                    "2025 YTD": "$484,000",
                    "Increase/DecreaseYTD": "2.2%",
                    Color: "#F0E68C",
                  })
                }
                stroke="black"
                fill={countyname === "Utah County" ? "#F0E68C80" : "#F0E68C"}
              ></path>
            </OverlayTrigger>

            <OverlayTrigger
              placement="right"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip29}
            >
              <path
                id="49057"
                className="county"
                d="M146.029,78.277L162.212,56.41L168.859,56.381L175.48,56.41L176.011,55.76L176.744,55.802L177.097,55.321L179.615,53.999L178.866,52.921L179.358,51.464L179.342,50.212L179.05,49.354L179.942,48.192L181.219,49.718L182.502,50.001L183.372,49.464L184.077,49.523L184.556,48.822L185.392,49.249L184.934,49.68L185.63,51.18L187.348,51.785L188.205,51.675L189.075,52.068L190.133,51.7L192.089,53.585L193.372,53.602L194.626,53.095L194.604,52.313L195.893,50.644L195.878,49.98L195.119,49.612L194.947,48.741L195.814,48.902L196.529,49.608L197.634,48.745L198.402,48.619L199.307,50.394L199.866,50.538L200.117,49.815L201.438,49.185L203.664,49.498L204.198,48.623L204.881,49.101L205.554,49.071L206.23,50.597L206.961,49.824L208.291,49.101L208.987,50.301L210.53,51.062L210.397,52.372L211.184,52.676L211.464,53.23L212.264,53.344L212.404,53.868L214.001,54.32L213.652,55.849L212.909,56.292L212.937,57.521L212.185,58.167L212.839,59.935L212.455,61.344L211.635,61.745L211.232,63.023L210.362,63.668L210.416,64.107L209.32,64.474L209.158,65.654L208.596,65.317L207.323,65.498L206.745,64.874L205.195,64.528L202.851,64.672L202.057,65.46L201.883,67.116L201.105,67.888L200.085,68.01L198.926,69.122L198.421,68.966L197.7,69.501L195.935,69.337L195.258,69.076L194.525,68.149L193.423,67.601L193.394,66.872L192.273,67.041L191.587,66.392L189.984,66.472L189.215,66.889L188.856,67.525L186.281,68.124L185.347,68.949L185.608,69.514L185.118,70.466L185.5,71.194L186.513,71.75L186.408,73.047L184.277,73.169L182.953,73.426L182.308,73.081L180.914,73.186L180.072,72.916L179.136,71.906L165.477,71.872Z"
                data-item='{"area":1492443861,"county":{"year":2024,"fips":49057,"pop2020":262988,"pop2024":274392,"state":"Utah","stateCode":"UT","growthSince2020":0.043363195278872,"name":"Weber County","county":"Weber County","slug":"utah/weber-county","landArea":611,"density":449.08674304418986,"rank":4,"densityMi":449.08674304418986,"areaMi":611}}'
                strokeWidth="1"
                onClick={() =>
                  showData({
                    "County Name": "Weber County",
                    "No: of Housing Units (Owner Occupied)": "68,853",
                    "Median Home Value": "$480K",
                    "04-2024": "$429,990",
                    "04-2025": "$460,000",
                    "Increase/Decrease": "7.0%",
                    "2024 YTD": "$424,425",
                    "2025 YTD": "$440,000",
                    "Increase/DecreaseYTD": "3.7%",
                    Color: "#E1C4FF",
                  })
                }
                stroke="black"
                fill={countyname === "Weber County" ? "#E1C4FF80" : "#E1C4FF"}
              ></path>
            </OverlayTrigger>
          </svg>

          <div className="utah-housing-legend-container">
            <h3 style={{ color: color, textAlign: "center" }}>{countyname}</h3>
            <div className="houseData">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <div className="legend-columns">
                  <img src={housingunits} alt="housing units" width={50} />
                </div>
                <div style={{ color: color, paddingLeft: "10px" }}>
                  <p style={{ padding: "0", margin: "0", color: "#ffc107" }}>
                    No.of Housing Units
                  </p>
                  <p style={{ padding: "0", margin: "0", fontWeight: "bold" }}>
                    {countyhouse}
                  </p>
                  <p style={{ padding: "0", margin: "0", color: "#ffc107" }}>
                    Owner Occupied
                  </p>
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <div className="legend-columns">
                  <img src={medianhomeimg} alt="median home" width={50} />
                </div>
                <div style={{ color: color, paddingLeft: "10px" }}>
                  <p style={{ padding: "0", margin: "0", color: "#ffc107" }}>
                    Median Home Value
                  </p>
                  <p style={{ padding: "0", margin: "0", fontWeight: "bold" }}>
                    {medianhome}
                  </p>
                  <p style={{ padding: "0", margin: "0", color: "#ffc107" }}>
                    In Dollar
                  </p>
                </div>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div className="legend-columns">
                <img src={updateimg} alt="median home" width={50} />
              </div>
              <div style={{ color: color, paddingLeft: "10px" }}>
                <p style={{ padding: "0", margin: "0", fontWeight: "bold" }}>
                  Local Market Updates (December 2024)
                </p>
              </div>
            </div>
            <div className="utah-housing-charts">
              <div className="charts">
                <UtahHousingChart data={chartsData} />
              </div>
              <div className="charts">
                <UtahHousingChartYTD data={chartsData} />
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-col items-end mr-24 gap-2">
          <p className="font-semibold text-sm">Data Sources:</p>
          <a
            target="_blank"
            href="https://utahrealtors.com/consumers/resources/statistics/"
            rel="noreferrer"
            className="text-sm text-blue-600 hover:text-blue-800 underline"
          >
            Utah Realtors - Statistics
          </a>
          <a
            target="_blank"
            href="https://datacommons.one.org/ranking/Count_HousingUnit_OwnerOccupied/County/geoId/49?h=geoId%2F49035"
            rel="noreferrer"
            className="text-sm text-blue-600 hover:text-blue-800 underline"
          >
            Data Commons - Housing Units
          </a>
          <a
            target="_blank"
            href="https://www.census.gov/topics/housing.html"
            rel="noreferrer"
            className="text-sm text-blue-600 hover:text-blue-800 underline"
          >
            U.S. Census Bureau - Housing
          </a>
          <a
            target="_blank"
            href="https://www.realtor.com/realestateandhomes-search/Utah-County_UT/overview"
            rel="noreferrer"
            className="text-sm text-blue-600 hover:text-blue-800 underline"
          >
            Realtor.com - Utah County Overview
          </a>
        </div>
      </div>
    </>
  );
};

export default UtahHousingMap;
